// Gerado automaticamente por app/scripts/generateWhatsAppEmojiSprites.js.
// Nao edite manualmente.

const whatsAppEmojiSprites = {
  "smileys": {
    "file": "smileys.94cbce4bc9be.webp",
    "width": 480,
    "height": 900
  },
  "natureza": {
    "file": "natureza.6c90eb8dbe00.webp",
    "width": 480,
    "height": 420
  },
  "comidas": {
    "file": "comidas.bb41b35e6dd7.webp",
    "width": 480,
    "height": 270
  },
  "atividades": {
    "file": "atividades.8d2d11d503f4.webp",
    "width": 480,
    "height": 240
  },
  "viagens": {
    "file": "viagens.478daf0cf0cf.webp",
    "width": 480,
    "height": 270
  },
  "objetos": {
    "file": "objetos.079ddcbcfc97.webp",
    "width": 480,
    "height": 450
  },
  "simbolos": {
    "file": "simbolos.5dc024376f25.webp",
    "width": 480,
    "height": 570
  },
  "bandeiras": {
    "file": "bandeiras.c8163c369e06.webp",
    "width": 480,
    "height": 510
  }
}

const whatsAppEmojiSpriteMap = {
  "2049": {
    "sprite": "simbolos",
    "x": 60,
    "y": 180
  },
  "2122": {
    "sprite": "simbolos",
    "x": 150,
    "y": 390
  },
  "2139": {
    "sprite": "simbolos",
    "x": 30,
    "y": 270
  },
  "2194": {
    "sprite": "simbolos",
    "x": 30,
    "y": 360
  },
  "2195": {
    "sprite": "simbolos",
    "x": 0,
    "y": 360
  },
  "2196": {
    "sprite": "simbolos",
    "x": 450,
    "y": 330
  },
  "2197": {
    "sprite": "simbolos",
    "x": 360,
    "y": 330
  },
  "2198": {
    "sprite": "simbolos",
    "x": 390,
    "y": 330
  },
  "2199": {
    "sprite": "simbolos",
    "x": 420,
    "y": 330
  },
  "2328": {
    "sprite": "objetos",
    "x": 120,
    "y": 0
  },
  "2600": {
    "sprite": "natureza",
    "x": 0,
    "y": 360
  },
  "2601": {
    "sprite": "natureza",
    "x": 120,
    "y": 360
  },
  "2602": {
    "sprite": "natureza",
    "x": 90,
    "y": 390
  },
  "2603": {
    "sprite": "natureza",
    "x": 330,
    "y": 360
  },
  "2604": {
    "sprite": "natureza",
    "x": 330,
    "y": 330
  },
  "2611": {
    "sprite": "simbolos",
    "x": 60,
    "y": 420
  },
  "2614": {
    "sprite": "natureza",
    "x": 60,
    "y": 390
  },
  "2615": {
    "sprite": "comidas",
    "x": 330,
    "y": 180
  },
  "2618": {
    "sprite": "natureza",
    "x": 300,
    "y": 240
  },
  "2620": {
    "sprite": "smileys",
    "x": 60,
    "y": 210
  },
  "2622": {
    "sprite": "simbolos",
    "x": 120,
    "y": 90
  },
  "2623": {
    "sprite": "simbolos",
    "x": 150,
    "y": 90
  },
  "2626": {
    "sprite": "simbolos",
    "x": 60,
    "y": 60
  },
  "2638": {
    "sprite": "simbolos",
    "x": 360,
    "y": 30
  },
  "2639": {
    "sprite": "smileys",
    "x": 360,
    "y": 60
  },
  "2648": {
    "sprite": "simbolos",
    "x": 150,
    "y": 60
  },
  "2649": {
    "sprite": "simbolos",
    "x": 180,
    "y": 60
  },
  "2650": {
    "sprite": "simbolos",
    "x": 390,
    "y": 60
  },
  "2651": {
    "sprite": "simbolos",
    "x": 420,
    "y": 60
  },
  "2652": {
    "sprite": "simbolos",
    "x": 450,
    "y": 60
  },
  "2653": {
    "sprite": "simbolos",
    "x": 0,
    "y": 90
  },
  "2660": {
    "sprite": "simbolos",
    "x": 450,
    "y": 480
  },
  "2663": {
    "sprite": "simbolos",
    "x": 0,
    "y": 510
  },
  "2665": {
    "sprite": "simbolos",
    "x": 30,
    "y": 510
  },
  "2666": {
    "sprite": "simbolos",
    "x": 60,
    "y": 510
  },
  "2668": {
    "sprite": "simbolos",
    "x": 150,
    "y": 150
  },
  "2692": {
    "sprite": "objetos",
    "x": 0,
    "y": 120
  },
  "2693": {
    "sprite": "viagens",
    "x": 390,
    "y": 90
  },
  "2694": {
    "sprite": "objetos",
    "x": 60,
    "y": 150
  },
  "2696": {
    "sprite": "objetos",
    "x": 300,
    "y": 90
  },
  "2697": {
    "sprite": "objetos",
    "x": 420,
    "y": 150
  },
  "2699": {
    "sprite": "objetos",
    "x": 180,
    "y": 120
  },
  "2702": {
    "sprite": "objetos",
    "x": 120,
    "y": 390
  },
  "2705": {
    "sprite": "simbolos",
    "x": 360,
    "y": 180
  },
  "2708": {
    "sprite": "viagens",
    "x": 360,
    "y": 60
  },
  "2709": {
    "sprite": "objetos",
    "x": 300,
    "y": 270
  },
  "2712": {
    "sprite": "objetos",
    "x": 210,
    "y": 390
  },
  "2714": {
    "sprite": "simbolos",
    "x": 30,
    "y": 420
  },
  "2716": {
    "sprite": "simbolos",
    "x": 0,
    "y": 390
  },
  "2721": {
    "sprite": "simbolos",
    "x": 420,
    "y": 30
  },
  "2728": {
    "sprite": "natureza",
    "x": 270,
    "y": 330
  },
  "2733": {
    "sprite": "simbolos",
    "x": 0,
    "y": 210
  },
  "2734": {
    "sprite": "simbolos",
    "x": 390,
    "y": 90
  },
  "2744": {
    "sprite": "natureza",
    "x": 300,
    "y": 360
  },
  "2747": {
    "sprite": "simbolos",
    "x": 450,
    "y": 180
  },
  "2753": {
    "sprite": "simbolos",
    "x": 450,
    "y": 150
  },
  "2754": {
    "sprite": "simbolos",
    "x": 0,
    "y": 180
  },
  "2755": {
    "sprite": "simbolos",
    "x": 420,
    "y": 150
  },
  "2757": {
    "sprite": "simbolos",
    "x": 390,
    "y": 150
  },
  "2763": {
    "sprite": "simbolos",
    "x": 450,
    "y": 0
  },
  "2764": {
    "sprite": "simbolos",
    "x": 30,
    "y": 0
  },
  "2795": {
    "sprite": "simbolos",
    "x": 390,
    "y": 360
  },
  "2796": {
    "sprite": "simbolos",
    "x": 420,
    "y": 360
  },
  "2797": {
    "sprite": "simbolos",
    "x": 450,
    "y": 360
  },
  "2934": {
    "sprite": "simbolos",
    "x": 120,
    "y": 360
  },
  "2935": {
    "sprite": "simbolos",
    "x": 150,
    "y": 360
  },
  "3030": {
    "sprite": "simbolos",
    "x": 420,
    "y": 390
  },
  "3297": {
    "sprite": "simbolos",
    "x": 60,
    "y": 120
  },
  "3299": {
    "sprite": "simbolos",
    "x": 30,
    "y": 120
  },
  "1f600": {
    "sprite": "smileys",
    "x": 0,
    "y": 0
  },
  "1f603": {
    "sprite": "smileys",
    "x": 30,
    "y": 0
  },
  "1f604": {
    "sprite": "smileys",
    "x": 60,
    "y": 0
  },
  "1f601": {
    "sprite": "smileys",
    "x": 90,
    "y": 0
  },
  "1f606": {
    "sprite": "smileys",
    "x": 120,
    "y": 0
  },
  "1f979": {
    "sprite": "smileys",
    "x": 150,
    "y": 0
  },
  "1f605": {
    "sprite": "smileys",
    "x": 180,
    "y": 0
  },
  "1f602": {
    "sprite": "smileys",
    "x": 210,
    "y": 0
  },
  "1f923": {
    "sprite": "smileys",
    "x": 240,
    "y": 0
  },
  "1f972": {
    "sprite": "smileys",
    "x": 270,
    "y": 0
  },
  "263a": {
    "sprite": "smileys",
    "x": 300,
    "y": 0
  },
  "1f60a": {
    "sprite": "smileys",
    "x": 330,
    "y": 0
  },
  "1f607": {
    "sprite": "smileys",
    "x": 360,
    "y": 0
  },
  "1f642": {
    "sprite": "smileys",
    "x": 390,
    "y": 0
  },
  "1f643": {
    "sprite": "smileys",
    "x": 420,
    "y": 0
  },
  "1f609": {
    "sprite": "smileys",
    "x": 450,
    "y": 0
  },
  "1f60c": {
    "sprite": "smileys",
    "x": 0,
    "y": 30
  },
  "1f60d": {
    "sprite": "smileys",
    "x": 30,
    "y": 30
  },
  "1f970": {
    "sprite": "smileys",
    "x": 60,
    "y": 30
  },
  "1f618": {
    "sprite": "smileys",
    "x": 90,
    "y": 30
  },
  "1f617": {
    "sprite": "smileys",
    "x": 120,
    "y": 30
  },
  "1f619": {
    "sprite": "smileys",
    "x": 150,
    "y": 30
  },
  "1f61a": {
    "sprite": "smileys",
    "x": 180,
    "y": 30
  },
  "1f60b": {
    "sprite": "smileys",
    "x": 210,
    "y": 30
  },
  "1f61b": {
    "sprite": "smileys",
    "x": 240,
    "y": 30
  },
  "1f61d": {
    "sprite": "smileys",
    "x": 270,
    "y": 30
  },
  "1f61c": {
    "sprite": "smileys",
    "x": 300,
    "y": 30
  },
  "1f92a": {
    "sprite": "smileys",
    "x": 330,
    "y": 30
  },
  "1f928": {
    "sprite": "smileys",
    "x": 360,
    "y": 30
  },
  "1f9d0": {
    "sprite": "smileys",
    "x": 390,
    "y": 30
  },
  "1f913": {
    "sprite": "smileys",
    "x": 420,
    "y": 30
  },
  "1f60e": {
    "sprite": "smileys",
    "x": 450,
    "y": 30
  },
  "1f978": {
    "sprite": "smileys",
    "x": 0,
    "y": 60
  },
  "1f929": {
    "sprite": "smileys",
    "x": 30,
    "y": 60
  },
  "1f973": {
    "sprite": "smileys",
    "x": 60,
    "y": 60
  },
  "1f642-200d-2195": {
    "sprite": "smileys",
    "x": 90,
    "y": 60
  },
  "1f60f": {
    "sprite": "smileys",
    "x": 120,
    "y": 60
  },
  "1f612": {
    "sprite": "smileys",
    "x": 150,
    "y": 60
  },
  "1f642-200d-2194": {
    "sprite": "smileys",
    "x": 180,
    "y": 60
  },
  "1f61e": {
    "sprite": "smileys",
    "x": 210,
    "y": 60
  },
  "1f614": {
    "sprite": "smileys",
    "x": 240,
    "y": 60
  },
  "1f61f": {
    "sprite": "smileys",
    "x": 270,
    "y": 60
  },
  "1f615": {
    "sprite": "smileys",
    "x": 300,
    "y": 60
  },
  "1f641": {
    "sprite": "smileys",
    "x": 330,
    "y": 60
  },
  "1f623": {
    "sprite": "smileys",
    "x": 390,
    "y": 60
  },
  "1f616": {
    "sprite": "smileys",
    "x": 420,
    "y": 60
  },
  "1f62b": {
    "sprite": "smileys",
    "x": 450,
    "y": 60
  },
  "1f629": {
    "sprite": "smileys",
    "x": 0,
    "y": 90
  },
  "1f97a": {
    "sprite": "smileys",
    "x": 30,
    "y": 90
  },
  "1f622": {
    "sprite": "smileys",
    "x": 60,
    "y": 90
  },
  "1f62d": {
    "sprite": "smileys",
    "x": 90,
    "y": 90
  },
  "1f624": {
    "sprite": "smileys",
    "x": 120,
    "y": 90
  },
  "1f620": {
    "sprite": "smileys",
    "x": 150,
    "y": 90
  },
  "1f621": {
    "sprite": "smileys",
    "x": 180,
    "y": 90
  },
  "1f92c": {
    "sprite": "smileys",
    "x": 210,
    "y": 90
  },
  "1f92f": {
    "sprite": "smileys",
    "x": 240,
    "y": 90
  },
  "1f633": {
    "sprite": "smileys",
    "x": 270,
    "y": 90
  },
  "1f975": {
    "sprite": "smileys",
    "x": 300,
    "y": 90
  },
  "1f976": {
    "sprite": "smileys",
    "x": 330,
    "y": 90
  },
  "1f636-200d-1f32b": {
    "sprite": "smileys",
    "x": 360,
    "y": 90
  },
  "1f631": {
    "sprite": "smileys",
    "x": 390,
    "y": 90
  },
  "1f628": {
    "sprite": "smileys",
    "x": 420,
    "y": 90
  },
  "1f630": {
    "sprite": "smileys",
    "x": 450,
    "y": 90
  },
  "1f625": {
    "sprite": "smileys",
    "x": 0,
    "y": 120
  },
  "1f613": {
    "sprite": "smileys",
    "x": 30,
    "y": 120
  },
  "1f917": {
    "sprite": "smileys",
    "x": 60,
    "y": 120
  },
  "1f914": {
    "sprite": "smileys",
    "x": 90,
    "y": 120
  },
  "1fae3": {
    "sprite": "smileys",
    "x": 120,
    "y": 120
  },
  "1f92d": {
    "sprite": "smileys",
    "x": 150,
    "y": 120
  },
  "1fae2": {
    "sprite": "smileys",
    "x": 180,
    "y": 120
  },
  "1fae1": {
    "sprite": "smileys",
    "x": 210,
    "y": 120
  },
  "1f92b": {
    "sprite": "smileys",
    "x": 240,
    "y": 120
  },
  "1fae0": {
    "sprite": "smileys",
    "x": 270,
    "y": 120
  },
  "1f925": {
    "sprite": "smileys",
    "x": 300,
    "y": 120
  },
  "1f636": {
    "sprite": "smileys",
    "x": 330,
    "y": 120
  },
  "1fae5": {
    "sprite": "smileys",
    "x": 360,
    "y": 120
  },
  "1f610": {
    "sprite": "smileys",
    "x": 390,
    "y": 120
  },
  "1fae4": {
    "sprite": "smileys",
    "x": 420,
    "y": 120
  },
  "1f611": {
    "sprite": "smileys",
    "x": 450,
    "y": 120
  },
  "1fae8": {
    "sprite": "smileys",
    "x": 0,
    "y": 150
  },
  "1f62c": {
    "sprite": "smileys",
    "x": 30,
    "y": 150
  },
  "1f644": {
    "sprite": "smileys",
    "x": 60,
    "y": 150
  },
  "1f62f": {
    "sprite": "smileys",
    "x": 90,
    "y": 150
  },
  "1f626": {
    "sprite": "smileys",
    "x": 120,
    "y": 150
  },
  "1f627": {
    "sprite": "smileys",
    "x": 150,
    "y": 150
  },
  "1f62e": {
    "sprite": "smileys",
    "x": 180,
    "y": 150
  },
  "1f632": {
    "sprite": "smileys",
    "x": 210,
    "y": 150
  },
  "1f971": {
    "sprite": "smileys",
    "x": 240,
    "y": 150
  },
  "1fae9": {
    "sprite": "smileys",
    "x": 270,
    "y": 150
  },
  "1f634": {
    "sprite": "smileys",
    "x": 300,
    "y": 150
  },
  "1f924": {
    "sprite": "smileys",
    "x": 330,
    "y": 150
  },
  "1f62a": {
    "sprite": "smileys",
    "x": 360,
    "y": 150
  },
  "1f62e-200d-1f4a8": {
    "sprite": "smileys",
    "x": 390,
    "y": 150
  },
  "1f635": {
    "sprite": "smileys",
    "x": 420,
    "y": 150
  },
  "1f635-200d-1f4ab": {
    "sprite": "smileys",
    "x": 450,
    "y": 150
  },
  "1f910": {
    "sprite": "smileys",
    "x": 0,
    "y": 180
  },
  "1f974": {
    "sprite": "smileys",
    "x": 30,
    "y": 180
  },
  "1f922": {
    "sprite": "smileys",
    "x": 60,
    "y": 180
  },
  "1f92e": {
    "sprite": "smileys",
    "x": 90,
    "y": 180
  },
  "1f927": {
    "sprite": "smileys",
    "x": 120,
    "y": 180
  },
  "1f637": {
    "sprite": "smileys",
    "x": 150,
    "y": 180
  },
  "1f912": {
    "sprite": "smileys",
    "x": 180,
    "y": 180
  },
  "1f915": {
    "sprite": "smileys",
    "x": 210,
    "y": 180
  },
  "1f911": {
    "sprite": "smileys",
    "x": 240,
    "y": 180
  },
  "1f920": {
    "sprite": "smileys",
    "x": 270,
    "y": 180
  },
  "1f608": {
    "sprite": "smileys",
    "x": 300,
    "y": 180
  },
  "1f47f": {
    "sprite": "smileys",
    "x": 330,
    "y": 180
  },
  "1f479": {
    "sprite": "smileys",
    "x": 360,
    "y": 180
  },
  "1f47a": {
    "sprite": "smileys",
    "x": 390,
    "y": 180
  },
  "1f921": {
    "sprite": "smileys",
    "x": 420,
    "y": 180
  },
  "1f4a9": {
    "sprite": "smileys",
    "x": 450,
    "y": 180
  },
  "1f47b": {
    "sprite": "smileys",
    "x": 0,
    "y": 210
  },
  "1f480": {
    "sprite": "smileys",
    "x": 30,
    "y": 210
  },
  "1f47d": {
    "sprite": "smileys",
    "x": 90,
    "y": 210
  },
  "1f47e": {
    "sprite": "smileys",
    "x": 120,
    "y": 210
  },
  "1f916": {
    "sprite": "smileys",
    "x": 150,
    "y": 210
  },
  "1f383": {
    "sprite": "smileys",
    "x": 180,
    "y": 210
  },
  "1f63a": {
    "sprite": "smileys",
    "x": 210,
    "y": 210
  },
  "1f638": {
    "sprite": "smileys",
    "x": 240,
    "y": 210
  },
  "1f639": {
    "sprite": "smileys",
    "x": 270,
    "y": 210
  },
  "1f63b": {
    "sprite": "smileys",
    "x": 300,
    "y": 210
  },
  "1f63c": {
    "sprite": "smileys",
    "x": 330,
    "y": 210
  },
  "1f63d": {
    "sprite": "smileys",
    "x": 360,
    "y": 210
  },
  "1f640": {
    "sprite": "smileys",
    "x": 390,
    "y": 210
  },
  "1f63f": {
    "sprite": "smileys",
    "x": 420,
    "y": 210
  },
  "1f63e": {
    "sprite": "smileys",
    "x": 450,
    "y": 210
  },
  "1faf6": {
    "sprite": "smileys",
    "x": 0,
    "y": 240
  },
  "1f932": {
    "sprite": "smileys",
    "x": 30,
    "y": 240
  },
  "1f450": {
    "sprite": "smileys",
    "x": 60,
    "y": 240
  },
  "1f64c": {
    "sprite": "smileys",
    "x": 90,
    "y": 240
  },
  "1f44f": {
    "sprite": "smileys",
    "x": 120,
    "y": 240
  },
  "1f91d": {
    "sprite": "smileys",
    "x": 150,
    "y": 240
  },
  "1f44d": {
    "sprite": "smileys",
    "x": 180,
    "y": 240
  },
  "1f44e": {
    "sprite": "smileys",
    "x": 210,
    "y": 240
  },
  "1f44a": {
    "sprite": "smileys",
    "x": 240,
    "y": 240
  },
  "270a": {
    "sprite": "smileys",
    "x": 270,
    "y": 240
  },
  "1f91b": {
    "sprite": "smileys",
    "x": 300,
    "y": 240
  },
  "1f91c": {
    "sprite": "smileys",
    "x": 330,
    "y": 240
  },
  "1faf7": {
    "sprite": "smileys",
    "x": 360,
    "y": 240
  },
  "1faf8": {
    "sprite": "smileys",
    "x": 390,
    "y": 240
  },
  "1f91e": {
    "sprite": "smileys",
    "x": 420,
    "y": 240
  },
  "270c": {
    "sprite": "smileys",
    "x": 450,
    "y": 240
  },
  "1faf0": {
    "sprite": "smileys",
    "x": 0,
    "y": 270
  },
  "1f91f": {
    "sprite": "smileys",
    "x": 30,
    "y": 270
  },
  "1f918": {
    "sprite": "smileys",
    "x": 60,
    "y": 270
  },
  "1f44c": {
    "sprite": "smileys",
    "x": 90,
    "y": 270
  },
  "1f90c": {
    "sprite": "smileys",
    "x": 120,
    "y": 270
  },
  "1f90f": {
    "sprite": "smileys",
    "x": 150,
    "y": 270
  },
  "1faf3": {
    "sprite": "smileys",
    "x": 180,
    "y": 270
  },
  "1faf4": {
    "sprite": "smileys",
    "x": 210,
    "y": 270
  },
  "1f448": {
    "sprite": "smileys",
    "x": 240,
    "y": 270
  },
  "1f449": {
    "sprite": "smileys",
    "x": 270,
    "y": 270
  },
  "1f446": {
    "sprite": "smileys",
    "x": 300,
    "y": 270
  },
  "1f447": {
    "sprite": "smileys",
    "x": 330,
    "y": 270
  },
  "261d": {
    "sprite": "smileys",
    "x": 360,
    "y": 270
  },
  "270b": {
    "sprite": "smileys",
    "x": 390,
    "y": 270
  },
  "1f91a": {
    "sprite": "smileys",
    "x": 420,
    "y": 270
  },
  "1f590": {
    "sprite": "smileys",
    "x": 450,
    "y": 270
  },
  "1f596": {
    "sprite": "smileys",
    "x": 0,
    "y": 300
  },
  "1f44b": {
    "sprite": "smileys",
    "x": 30,
    "y": 300
  },
  "1f919": {
    "sprite": "smileys",
    "x": 60,
    "y": 300
  },
  "1faf2": {
    "sprite": "smileys",
    "x": 90,
    "y": 300
  },
  "1faf1": {
    "sprite": "smileys",
    "x": 120,
    "y": 300
  },
  "1f4aa": {
    "sprite": "smileys",
    "x": 150,
    "y": 300
  },
  "1f9be": {
    "sprite": "smileys",
    "x": 180,
    "y": 300
  },
  "1f595": {
    "sprite": "smileys",
    "x": 210,
    "y": 300
  },
  "270d": {
    "sprite": "smileys",
    "x": 240,
    "y": 300
  },
  "1f64f": {
    "sprite": "smileys",
    "x": 270,
    "y": 300
  },
  "1faf5": {
    "sprite": "smileys",
    "x": 300,
    "y": 300
  },
  "1f9b6": {
    "sprite": "smileys",
    "x": 330,
    "y": 300
  },
  "1f9b5": {
    "sprite": "smileys",
    "x": 360,
    "y": 300
  },
  "1f9bf": {
    "sprite": "smileys",
    "x": 390,
    "y": 300
  },
  "1f484": {
    "sprite": "smileys",
    "x": 420,
    "y": 300
  },
  "1f48b": {
    "sprite": "smileys",
    "x": 450,
    "y": 300
  },
  "1f444": {
    "sprite": "smileys",
    "x": 0,
    "y": 330
  },
  "1fae6": {
    "sprite": "smileys",
    "x": 30,
    "y": 330
  },
  "1f9b7": {
    "sprite": "smileys",
    "x": 60,
    "y": 330
  },
  "1f445": {
    "sprite": "smileys",
    "x": 90,
    "y": 330
  },
  "1f442": {
    "sprite": "smileys",
    "x": 120,
    "y": 330
  },
  "1f9bb": {
    "sprite": "smileys",
    "x": 150,
    "y": 330
  },
  "1f443": {
    "sprite": "smileys",
    "x": 180,
    "y": 330
  },
  "1fac6": {
    "sprite": "smileys",
    "x": 210,
    "y": 330
  },
  "1f463": {
    "sprite": "smileys",
    "x": 240,
    "y": 330
  },
  "1f441": {
    "sprite": "smileys",
    "x": 270,
    "y": 330
  },
  "1f440": {
    "sprite": "smileys",
    "x": 300,
    "y": 330
  },
  "1fac0": {
    "sprite": "smileys",
    "x": 330,
    "y": 330
  },
  "1fac1": {
    "sprite": "smileys",
    "x": 360,
    "y": 330
  },
  "1f9e0": {
    "sprite": "smileys",
    "x": 390,
    "y": 330
  },
  "1f5e3": {
    "sprite": "smileys",
    "x": 420,
    "y": 330
  },
  "1f464": {
    "sprite": "smileys",
    "x": 450,
    "y": 330
  },
  "1f465": {
    "sprite": "smileys",
    "x": 0,
    "y": 360
  },
  "1fac2": {
    "sprite": "smileys",
    "x": 30,
    "y": 360
  },
  "1f476": {
    "sprite": "smileys",
    "x": 60,
    "y": 360
  },
  "1f467": {
    "sprite": "smileys",
    "x": 90,
    "y": 360
  },
  "1f9d2": {
    "sprite": "smileys",
    "x": 120,
    "y": 360
  },
  "1f466": {
    "sprite": "smileys",
    "x": 150,
    "y": 360
  },
  "1f469": {
    "sprite": "smileys",
    "x": 180,
    "y": 360
  },
  "1f9d1": {
    "sprite": "smileys",
    "x": 210,
    "y": 360
  },
  "1f468": {
    "sprite": "smileys",
    "x": 240,
    "y": 360
  },
  "1f469-200d-1f9b1": {
    "sprite": "smileys",
    "x": 270,
    "y": 360
  },
  "1f9d1-200d-1f9b1": {
    "sprite": "smileys",
    "x": 300,
    "y": 360
  },
  "1f468-200d-1f9b1": {
    "sprite": "smileys",
    "x": 330,
    "y": 360
  },
  "1f469-200d-1f9b0": {
    "sprite": "smileys",
    "x": 360,
    "y": 360
  },
  "1f9d1-200d-1f9b0": {
    "sprite": "smileys",
    "x": 390,
    "y": 360
  },
  "1f468-200d-1f9b0": {
    "sprite": "smileys",
    "x": 420,
    "y": 360
  },
  "1f471-200d-2640": {
    "sprite": "smileys",
    "x": 450,
    "y": 360
  },
  "1f471": {
    "sprite": "smileys",
    "x": 0,
    "y": 390
  },
  "1f471-200d-2642": {
    "sprite": "smileys",
    "x": 30,
    "y": 390
  },
  "1f469-200d-1f9b3": {
    "sprite": "smileys",
    "x": 60,
    "y": 390
  },
  "1f9d1-200d-1f9b3": {
    "sprite": "smileys",
    "x": 90,
    "y": 390
  },
  "1f468-200d-1f9b3": {
    "sprite": "smileys",
    "x": 120,
    "y": 390
  },
  "1f469-200d-1f9b2": {
    "sprite": "smileys",
    "x": 150,
    "y": 390
  },
  "1f9d1-200d-1f9b2": {
    "sprite": "smileys",
    "x": 180,
    "y": 390
  },
  "1f468-200d-1f9b2": {
    "sprite": "smileys",
    "x": 210,
    "y": 390
  },
  "1f9d4-200d-2640": {
    "sprite": "smileys",
    "x": 240,
    "y": 390
  },
  "1f9d4": {
    "sprite": "smileys",
    "x": 270,
    "y": 390
  },
  "1f9d4-200d-2642": {
    "sprite": "smileys",
    "x": 300,
    "y": 390
  },
  "1f475": {
    "sprite": "smileys",
    "x": 330,
    "y": 390
  },
  "1f9d3": {
    "sprite": "smileys",
    "x": 360,
    "y": 390
  },
  "1f474": {
    "sprite": "smileys",
    "x": 390,
    "y": 390
  },
  "1f472": {
    "sprite": "smileys",
    "x": 420,
    "y": 390
  },
  "1f473-200d-2640": {
    "sprite": "smileys",
    "x": 450,
    "y": 390
  },
  "1f473": {
    "sprite": "smileys",
    "x": 0,
    "y": 420
  },
  "1f473-200d-2642": {
    "sprite": "smileys",
    "x": 30,
    "y": 420
  },
  "1f9d5": {
    "sprite": "smileys",
    "x": 60,
    "y": 420
  },
  "1f46e-200d-2640": {
    "sprite": "smileys",
    "x": 90,
    "y": 420
  },
  "1f46e": {
    "sprite": "smileys",
    "x": 120,
    "y": 420
  },
  "1f46e-200d-2642": {
    "sprite": "smileys",
    "x": 150,
    "y": 420
  },
  "1f477-200d-2640": {
    "sprite": "smileys",
    "x": 180,
    "y": 420
  },
  "1f477": {
    "sprite": "smileys",
    "x": 210,
    "y": 420
  },
  "1f477-200d-2642": {
    "sprite": "smileys",
    "x": 240,
    "y": 420
  },
  "1f482-200d-2640": {
    "sprite": "smileys",
    "x": 270,
    "y": 420
  },
  "1f482": {
    "sprite": "smileys",
    "x": 300,
    "y": 420
  },
  "1f482-200d-2642": {
    "sprite": "smileys",
    "x": 330,
    "y": 420
  },
  "1f575-200d-2640": {
    "sprite": "smileys",
    "x": 360,
    "y": 420
  },
  "1f575": {
    "sprite": "smileys",
    "x": 390,
    "y": 420
  },
  "1f575-200d-2642": {
    "sprite": "smileys",
    "x": 420,
    "y": 420
  },
  "1f469-200d-2695": {
    "sprite": "smileys",
    "x": 450,
    "y": 420
  },
  "1f9d1-200d-2695": {
    "sprite": "smileys",
    "x": 0,
    "y": 450
  },
  "1f468-200d-2695": {
    "sprite": "smileys",
    "x": 30,
    "y": 450
  },
  "1f469-200d-1f33e": {
    "sprite": "smileys",
    "x": 60,
    "y": 450
  },
  "1f9d1-200d-1f33e": {
    "sprite": "smileys",
    "x": 90,
    "y": 450
  },
  "1f468-200d-1f33e": {
    "sprite": "smileys",
    "x": 120,
    "y": 450
  },
  "1f469-200d-1f373": {
    "sprite": "smileys",
    "x": 150,
    "y": 450
  },
  "1f9d1-200d-1f373": {
    "sprite": "smileys",
    "x": 180,
    "y": 450
  },
  "1f468-200d-1f373": {
    "sprite": "smileys",
    "x": 210,
    "y": 450
  },
  "1f469-200d-1f393": {
    "sprite": "smileys",
    "x": 240,
    "y": 450
  },
  "1f9d1-200d-1f393": {
    "sprite": "smileys",
    "x": 270,
    "y": 450
  },
  "1f468-200d-1f393": {
    "sprite": "smileys",
    "x": 300,
    "y": 450
  },
  "1f469-200d-1f3a4": {
    "sprite": "smileys",
    "x": 330,
    "y": 450
  },
  "1f9d1-200d-1f3a4": {
    "sprite": "smileys",
    "x": 360,
    "y": 450
  },
  "1f468-200d-1f3a4": {
    "sprite": "smileys",
    "x": 390,
    "y": 450
  },
  "1f469-200d-1f3eb": {
    "sprite": "smileys",
    "x": 420,
    "y": 450
  },
  "1f9d1-200d-1f3eb": {
    "sprite": "smileys",
    "x": 450,
    "y": 450
  },
  "1f468-200d-1f3eb": {
    "sprite": "smileys",
    "x": 0,
    "y": 480
  },
  "1f469-200d-1f3ed": {
    "sprite": "smileys",
    "x": 30,
    "y": 480
  },
  "1f9d1-200d-1f3ed": {
    "sprite": "smileys",
    "x": 60,
    "y": 480
  },
  "1f468-200d-1f3ed": {
    "sprite": "smileys",
    "x": 90,
    "y": 480
  },
  "1f469-200d-1f4bb": {
    "sprite": "smileys",
    "x": 120,
    "y": 480
  },
  "1f9d1-200d-1f4bb": {
    "sprite": "smileys",
    "x": 150,
    "y": 480
  },
  "1f468-200d-1f4bb": {
    "sprite": "smileys",
    "x": 180,
    "y": 480
  },
  "1f469-200d-1f4bc": {
    "sprite": "smileys",
    "x": 210,
    "y": 480
  },
  "1f9d1-200d-1f4bc": {
    "sprite": "smileys",
    "x": 240,
    "y": 480
  },
  "1f468-200d-1f4bc": {
    "sprite": "smileys",
    "x": 270,
    "y": 480
  },
  "1f469-200d-1f527": {
    "sprite": "smileys",
    "x": 300,
    "y": 480
  },
  "1f9d1-200d-1f527": {
    "sprite": "smileys",
    "x": 330,
    "y": 480
  },
  "1f468-200d-1f527": {
    "sprite": "smileys",
    "x": 360,
    "y": 480
  },
  "1f469-200d-1f52c": {
    "sprite": "smileys",
    "x": 390,
    "y": 480
  },
  "1f9d1-200d-1f52c": {
    "sprite": "smileys",
    "x": 420,
    "y": 480
  },
  "1f468-200d-1f52c": {
    "sprite": "smileys",
    "x": 450,
    "y": 480
  },
  "1f469-200d-1f3a8": {
    "sprite": "smileys",
    "x": 0,
    "y": 510
  },
  "1f9d1-200d-1f3a8": {
    "sprite": "smileys",
    "x": 30,
    "y": 510
  },
  "1f468-200d-1f3a8": {
    "sprite": "smileys",
    "x": 60,
    "y": 510
  },
  "1f469-200d-1f692": {
    "sprite": "smileys",
    "x": 90,
    "y": 510
  },
  "1f9d1-200d-1f692": {
    "sprite": "smileys",
    "x": 120,
    "y": 510
  },
  "1f468-200d-1f692": {
    "sprite": "smileys",
    "x": 150,
    "y": 510
  },
  "1f469-200d-2708": {
    "sprite": "smileys",
    "x": 180,
    "y": 510
  },
  "1f9d1-200d-2708": {
    "sprite": "smileys",
    "x": 210,
    "y": 510
  },
  "1f468-200d-2708": {
    "sprite": "smileys",
    "x": 240,
    "y": 510
  },
  "1f469-200d-1f680": {
    "sprite": "smileys",
    "x": 270,
    "y": 510
  },
  "1f9d1-200d-1f680": {
    "sprite": "smileys",
    "x": 300,
    "y": 510
  },
  "1f468-200d-1f680": {
    "sprite": "smileys",
    "x": 330,
    "y": 510
  },
  "1f469-200d-2696": {
    "sprite": "smileys",
    "x": 360,
    "y": 510
  },
  "1f9d1-200d-2696": {
    "sprite": "smileys",
    "x": 390,
    "y": 510
  },
  "1f468-200d-2696": {
    "sprite": "smileys",
    "x": 420,
    "y": 510
  },
  "1f470-200d-2640": {
    "sprite": "smileys",
    "x": 450,
    "y": 510
  },
  "1f470": {
    "sprite": "smileys",
    "x": 0,
    "y": 540
  },
  "1f470-200d-2642": {
    "sprite": "smileys",
    "x": 30,
    "y": 540
  },
  "1f935-200d-2640": {
    "sprite": "smileys",
    "x": 60,
    "y": 540
  },
  "1f935": {
    "sprite": "smileys",
    "x": 90,
    "y": 540
  },
  "1f935-200d-2642": {
    "sprite": "smileys",
    "x": 120,
    "y": 540
  },
  "1f478": {
    "sprite": "smileys",
    "x": 150,
    "y": 540
  },
  "1fac5": {
    "sprite": "smileys",
    "x": 180,
    "y": 540
  },
  "1f934": {
    "sprite": "smileys",
    "x": 210,
    "y": 540
  },
  "1f977": {
    "sprite": "smileys",
    "x": 240,
    "y": 540
  },
  "1f9b8-200d-2640": {
    "sprite": "smileys",
    "x": 270,
    "y": 540
  },
  "1f9b8": {
    "sprite": "smileys",
    "x": 300,
    "y": 540
  },
  "1f9b8-200d-2642": {
    "sprite": "smileys",
    "x": 330,
    "y": 540
  },
  "1f9b9-200d-2640": {
    "sprite": "smileys",
    "x": 360,
    "y": 540
  },
  "1f9b9": {
    "sprite": "smileys",
    "x": 390,
    "y": 540
  },
  "1f9b9-200d-2642": {
    "sprite": "smileys",
    "x": 420,
    "y": 540
  },
  "1f936": {
    "sprite": "smileys",
    "x": 450,
    "y": 540
  },
  "1f9d1-200d-1f384": {
    "sprite": "smileys",
    "x": 0,
    "y": 570
  },
  "1f385": {
    "sprite": "smileys",
    "x": 30,
    "y": 570
  },
  "1f9d9-200d-2640": {
    "sprite": "smileys",
    "x": 60,
    "y": 570
  },
  "1f9d9": {
    "sprite": "smileys",
    "x": 90,
    "y": 570
  },
  "1f9d9-200d-2642": {
    "sprite": "smileys",
    "x": 120,
    "y": 570
  },
  "1f9dd-200d-2640": {
    "sprite": "smileys",
    "x": 150,
    "y": 570
  },
  "1f9dd": {
    "sprite": "smileys",
    "x": 180,
    "y": 570
  },
  "1f9dd-200d-2642": {
    "sprite": "smileys",
    "x": 210,
    "y": 570
  },
  "1f9cc": {
    "sprite": "smileys",
    "x": 240,
    "y": 570
  },
  "1f9db-200d-2640": {
    "sprite": "smileys",
    "x": 270,
    "y": 570
  },
  "1f9db": {
    "sprite": "smileys",
    "x": 300,
    "y": 570
  },
  "1f9db-200d-2642": {
    "sprite": "smileys",
    "x": 330,
    "y": 570
  },
  "1f9df-200d-2640": {
    "sprite": "smileys",
    "x": 360,
    "y": 570
  },
  "1f9df": {
    "sprite": "smileys",
    "x": 390,
    "y": 570
  },
  "1f9df-200d-2642": {
    "sprite": "smileys",
    "x": 420,
    "y": 570
  },
  "1f9de-200d-2640": {
    "sprite": "smileys",
    "x": 450,
    "y": 570
  },
  "1f9de": {
    "sprite": "smileys",
    "x": 0,
    "y": 600
  },
  "1f9de-200d-2642": {
    "sprite": "smileys",
    "x": 30,
    "y": 600
  },
  "1f9dc-200d-2640": {
    "sprite": "smileys",
    "x": 60,
    "y": 600
  },
  "1f9dc": {
    "sprite": "smileys",
    "x": 90,
    "y": 600
  },
  "1f9dc-200d-2642": {
    "sprite": "smileys",
    "x": 120,
    "y": 600
  },
  "1f9da-200d-2640": {
    "sprite": "smileys",
    "x": 150,
    "y": 600
  },
  "1f9da": {
    "sprite": "smileys",
    "x": 180,
    "y": 600
  },
  "1f9da-200d-2642": {
    "sprite": "smileys",
    "x": 210,
    "y": 600
  },
  "1f47c": {
    "sprite": "smileys",
    "x": 240,
    "y": 600
  },
  "1f930": {
    "sprite": "smileys",
    "x": 270,
    "y": 600
  },
  "1fac4": {
    "sprite": "smileys",
    "x": 300,
    "y": 600
  },
  "1fac3": {
    "sprite": "smileys",
    "x": 330,
    "y": 600
  },
  "1f931": {
    "sprite": "smileys",
    "x": 360,
    "y": 600
  },
  "1f469-200d-1f37c": {
    "sprite": "smileys",
    "x": 390,
    "y": 600
  },
  "1f9d1-200d-1f37c": {
    "sprite": "smileys",
    "x": 420,
    "y": 600
  },
  "1f468-200d-1f37c": {
    "sprite": "smileys",
    "x": 450,
    "y": 600
  },
  "1f647-200d-2640": {
    "sprite": "smileys",
    "x": 0,
    "y": 630
  },
  "1f647": {
    "sprite": "smileys",
    "x": 30,
    "y": 630
  },
  "1f647-200d-2642": {
    "sprite": "smileys",
    "x": 60,
    "y": 630
  },
  "1f481-200d-2640": {
    "sprite": "smileys",
    "x": 90,
    "y": 630
  },
  "1f481": {
    "sprite": "smileys",
    "x": 120,
    "y": 630
  },
  "1f481-200d-2642": {
    "sprite": "smileys",
    "x": 150,
    "y": 630
  },
  "1f645-200d-2640": {
    "sprite": "smileys",
    "x": 180,
    "y": 630
  },
  "1f645": {
    "sprite": "smileys",
    "x": 210,
    "y": 630
  },
  "1f645-200d-2642": {
    "sprite": "smileys",
    "x": 240,
    "y": 630
  },
  "1f646-200d-2640": {
    "sprite": "smileys",
    "x": 270,
    "y": 630
  },
  "1f646": {
    "sprite": "smileys",
    "x": 300,
    "y": 630
  },
  "1f646-200d-2642": {
    "sprite": "smileys",
    "x": 330,
    "y": 630
  },
  "1f64b-200d-2640": {
    "sprite": "smileys",
    "x": 360,
    "y": 630
  },
  "1f64b": {
    "sprite": "smileys",
    "x": 390,
    "y": 630
  },
  "1f64b-200d-2642": {
    "sprite": "smileys",
    "x": 420,
    "y": 630
  },
  "1f9cf-200d-2640": {
    "sprite": "smileys",
    "x": 450,
    "y": 630
  },
  "1f9cf": {
    "sprite": "smileys",
    "x": 0,
    "y": 660
  },
  "1f9cf-200d-2642": {
    "sprite": "smileys",
    "x": 30,
    "y": 660
  },
  "1f926-200d-2640": {
    "sprite": "smileys",
    "x": 60,
    "y": 660
  },
  "1f926": {
    "sprite": "smileys",
    "x": 90,
    "y": 660
  },
  "1f926-200d-2642": {
    "sprite": "smileys",
    "x": 120,
    "y": 660
  },
  "1f937-200d-2640": {
    "sprite": "smileys",
    "x": 150,
    "y": 660
  },
  "1f937": {
    "sprite": "smileys",
    "x": 180,
    "y": 660
  },
  "1f937-200d-2642": {
    "sprite": "smileys",
    "x": 210,
    "y": 660
  },
  "1f64e-200d-2640": {
    "sprite": "smileys",
    "x": 240,
    "y": 660
  },
  "1f64e": {
    "sprite": "smileys",
    "x": 270,
    "y": 660
  },
  "1f64e-200d-2642": {
    "sprite": "smileys",
    "x": 300,
    "y": 660
  },
  "1f64d-200d-2640": {
    "sprite": "smileys",
    "x": 330,
    "y": 660
  },
  "1f64d": {
    "sprite": "smileys",
    "x": 360,
    "y": 660
  },
  "1f64d-200d-2642": {
    "sprite": "smileys",
    "x": 390,
    "y": 660
  },
  "1f487-200d-2640": {
    "sprite": "smileys",
    "x": 420,
    "y": 660
  },
  "1f487": {
    "sprite": "smileys",
    "x": 450,
    "y": 660
  },
  "1f487-200d-2642": {
    "sprite": "smileys",
    "x": 0,
    "y": 690
  },
  "1f486-200d-2640": {
    "sprite": "smileys",
    "x": 30,
    "y": 690
  },
  "1f486": {
    "sprite": "smileys",
    "x": 60,
    "y": 690
  },
  "1f486-200d-2642": {
    "sprite": "smileys",
    "x": 90,
    "y": 690
  },
  "1f9d6-200d-2640": {
    "sprite": "smileys",
    "x": 120,
    "y": 690
  },
  "1f9d6": {
    "sprite": "smileys",
    "x": 150,
    "y": 690
  },
  "1f9d6-200d-2642": {
    "sprite": "smileys",
    "x": 180,
    "y": 690
  },
  "1f485": {
    "sprite": "smileys",
    "x": 210,
    "y": 690
  },
  "1f933": {
    "sprite": "smileys",
    "x": 240,
    "y": 690
  },
  "1f483": {
    "sprite": "smileys",
    "x": 270,
    "y": 690
  },
  "1f57a": {
    "sprite": "smileys",
    "x": 300,
    "y": 690
  },
  "1f46f-200d-2640": {
    "sprite": "smileys",
    "x": 330,
    "y": 690
  },
  "1f46f": {
    "sprite": "smileys",
    "x": 360,
    "y": 690
  },
  "1f46f-200d-2642": {
    "sprite": "smileys",
    "x": 390,
    "y": 690
  },
  "1f574": {
    "sprite": "smileys",
    "x": 420,
    "y": 690
  },
  "1f469-200d-1f9bd": {
    "sprite": "smileys",
    "x": 450,
    "y": 690
  },
  "1f9d1-200d-1f9bd": {
    "sprite": "smileys",
    "x": 0,
    "y": 720
  },
  "1f468-200d-1f9bd": {
    "sprite": "smileys",
    "x": 30,
    "y": 720
  },
  "1f469-200d-1f9bd-200d-27a1": {
    "sprite": "smileys",
    "x": 60,
    "y": 720
  },
  "1f9d1-200d-1f9bd-200d-27a1": {
    "sprite": "smileys",
    "x": 90,
    "y": 720
  },
  "1f468-200d-1f9bd-200d-27a1": {
    "sprite": "smileys",
    "x": 120,
    "y": 720
  },
  "1f469-200d-1f9bc": {
    "sprite": "smileys",
    "x": 150,
    "y": 720
  },
  "1f9d1-200d-1f9bc": {
    "sprite": "smileys",
    "x": 180,
    "y": 720
  },
  "1f468-200d-1f9bc": {
    "sprite": "smileys",
    "x": 210,
    "y": 720
  },
  "1f469-200d-1f9bc-200d-27a1": {
    "sprite": "smileys",
    "x": 240,
    "y": 720
  },
  "1f9d1-200d-1f9bc-200d-27a1": {
    "sprite": "smileys",
    "x": 270,
    "y": 720
  },
  "1f468-200d-1f9bc-200d-27a1": {
    "sprite": "smileys",
    "x": 300,
    "y": 720
  },
  "1f6b6-200d-2640": {
    "sprite": "smileys",
    "x": 330,
    "y": 720
  },
  "1f6b6": {
    "sprite": "smileys",
    "x": 360,
    "y": 720
  },
  "1f6b6-200d-2642": {
    "sprite": "smileys",
    "x": 390,
    "y": 720
  },
  "1f6b6-200d-2640-200d-27a1": {
    "sprite": "smileys",
    "x": 420,
    "y": 720
  },
  "1f6b6-200d-27a1": {
    "sprite": "smileys",
    "x": 450,
    "y": 720
  },
  "1f6b6-200d-2642-200d-27a1": {
    "sprite": "smileys",
    "x": 0,
    "y": 750
  },
  "1f469-200d-1f9af": {
    "sprite": "smileys",
    "x": 30,
    "y": 750
  },
  "1f9d1-200d-1f9af": {
    "sprite": "smileys",
    "x": 60,
    "y": 750
  },
  "1f468-200d-1f9af": {
    "sprite": "smileys",
    "x": 90,
    "y": 750
  },
  "1f469-200d-1f9af-200d-27a1": {
    "sprite": "smileys",
    "x": 120,
    "y": 750
  },
  "1f9d1-200d-1f9af-200d-27a1": {
    "sprite": "smileys",
    "x": 150,
    "y": 750
  },
  "1f468-200d-1f9af-200d-27a1": {
    "sprite": "smileys",
    "x": 180,
    "y": 750
  },
  "1f9ce-200d-2640": {
    "sprite": "smileys",
    "x": 210,
    "y": 750
  },
  "1f9ce": {
    "sprite": "smileys",
    "x": 240,
    "y": 750
  },
  "1f9ce-200d-2642": {
    "sprite": "smileys",
    "x": 270,
    "y": 750
  },
  "1f3c3-200d-2640": {
    "sprite": "smileys",
    "x": 300,
    "y": 750
  },
  "1f3c3": {
    "sprite": "smileys",
    "x": 330,
    "y": 750
  },
  "1f3c3-200d-2642": {
    "sprite": "smileys",
    "x": 360,
    "y": 750
  },
  "1f3c3-200d-2640-200d-27a1": {
    "sprite": "smileys",
    "x": 390,
    "y": 750
  },
  "1f3c3-200d-27a1": {
    "sprite": "smileys",
    "x": 420,
    "y": 750
  },
  "1f3c3-200d-2642-200d-27a1": {
    "sprite": "smileys",
    "x": 450,
    "y": 750
  },
  "1f9ce-200d-2640-200d-27a1": {
    "sprite": "smileys",
    "x": 0,
    "y": 780
  },
  "1f9ce-200d-27a1": {
    "sprite": "smileys",
    "x": 30,
    "y": 780
  },
  "1f9ce-200d-2642-200d-27a1": {
    "sprite": "smileys",
    "x": 60,
    "y": 780
  },
  "1f9cd-200d-2640": {
    "sprite": "smileys",
    "x": 90,
    "y": 780
  },
  "1f9cd": {
    "sprite": "smileys",
    "x": 120,
    "y": 780
  },
  "1f9cd-200d-2642": {
    "sprite": "smileys",
    "x": 150,
    "y": 780
  },
  "1f46b": {
    "sprite": "smileys",
    "x": 180,
    "y": 780
  },
  "1f46d": {
    "sprite": "smileys",
    "x": 210,
    "y": 780
  },
  "1f46c": {
    "sprite": "smileys",
    "x": 240,
    "y": 780
  },
  "1f469-200d-2764-200d-1f468": {
    "sprite": "smileys",
    "x": 270,
    "y": 780
  },
  "1f469-200d-2764-200d-1f469": {
    "sprite": "smileys",
    "x": 300,
    "y": 780
  },
  "1f491": {
    "sprite": "smileys",
    "x": 330,
    "y": 780
  },
  "1f468-200d-2764-200d-1f468": {
    "sprite": "smileys",
    "x": 360,
    "y": 780
  },
  "1f469-200d-2764-200d-1f48b-200d-1f468": {
    "sprite": "smileys",
    "x": 390,
    "y": 780
  },
  "1f469-200d-2764-200d-1f48b-200d-1f469": {
    "sprite": "smileys",
    "x": 420,
    "y": 780
  },
  "1f48f": {
    "sprite": "smileys",
    "x": 450,
    "y": 780
  },
  "1f468-200d-2764-200d-1f48b-200d-1f468": {
    "sprite": "smileys",
    "x": 0,
    "y": 810
  },
  "1faa2": {
    "sprite": "smileys",
    "x": 30,
    "y": 810
  },
  "1f9f6": {
    "sprite": "smileys",
    "x": 60,
    "y": 810
  },
  "1f9f5": {
    "sprite": "smileys",
    "x": 90,
    "y": 810
  },
  "1faa1": {
    "sprite": "smileys",
    "x": 120,
    "y": 810
  },
  "1f9e5": {
    "sprite": "smileys",
    "x": 150,
    "y": 810
  },
  "1f97c": {
    "sprite": "smileys",
    "x": 180,
    "y": 810
  },
  "1f9ba": {
    "sprite": "smileys",
    "x": 210,
    "y": 810
  },
  "1f45a": {
    "sprite": "smileys",
    "x": 240,
    "y": 810
  },
  "1f455": {
    "sprite": "smileys",
    "x": 270,
    "y": 810
  },
  "1f456": {
    "sprite": "smileys",
    "x": 300,
    "y": 810
  },
  "1fa72": {
    "sprite": "smileys",
    "x": 330,
    "y": 810
  },
  "1fa73": {
    "sprite": "smileys",
    "x": 360,
    "y": 810
  },
  "1f454": {
    "sprite": "smileys",
    "x": 390,
    "y": 810
  },
  "1f457": {
    "sprite": "smileys",
    "x": 420,
    "y": 810
  },
  "1f459": {
    "sprite": "smileys",
    "x": 450,
    "y": 810
  },
  "1fa71": {
    "sprite": "smileys",
    "x": 0,
    "y": 840
  },
  "1f458": {
    "sprite": "smileys",
    "x": 30,
    "y": 840
  },
  "1f97b": {
    "sprite": "smileys",
    "x": 60,
    "y": 840
  },
  "1fa74": {
    "sprite": "smileys",
    "x": 90,
    "y": 840
  },
  "1f97f": {
    "sprite": "smileys",
    "x": 120,
    "y": 840
  },
  "1f460": {
    "sprite": "smileys",
    "x": 150,
    "y": 840
  },
  "1f461": {
    "sprite": "smileys",
    "x": 180,
    "y": 840
  },
  "1f462": {
    "sprite": "smileys",
    "x": 210,
    "y": 840
  },
  "1f45e": {
    "sprite": "smileys",
    "x": 240,
    "y": 840
  },
  "1f45f": {
    "sprite": "smileys",
    "x": 270,
    "y": 840
  },
  "1f97e": {
    "sprite": "smileys",
    "x": 300,
    "y": 840
  },
  "1f9e6": {
    "sprite": "smileys",
    "x": 330,
    "y": 840
  },
  "1f9e4": {
    "sprite": "smileys",
    "x": 360,
    "y": 840
  },
  "1f9e3": {
    "sprite": "smileys",
    "x": 390,
    "y": 840
  },
  "1f3a9": {
    "sprite": "smileys",
    "x": 420,
    "y": 840
  },
  "1f9e2": {
    "sprite": "smileys",
    "x": 450,
    "y": 840
  },
  "1f452": {
    "sprite": "smileys",
    "x": 0,
    "y": 870
  },
  "1f393": {
    "sprite": "smileys",
    "x": 30,
    "y": 870
  },
  "26d1": {
    "sprite": "smileys",
    "x": 60,
    "y": 870
  },
  "1fa96": {
    "sprite": "smileys",
    "x": 90,
    "y": 870
  },
  "1f451": {
    "sprite": "smileys",
    "x": 120,
    "y": 870
  },
  "1f48d": {
    "sprite": "smileys",
    "x": 150,
    "y": 870
  },
  "1f45d": {
    "sprite": "smileys",
    "x": 180,
    "y": 870
  },
  "1f45b": {
    "sprite": "smileys",
    "x": 210,
    "y": 870
  },
  "1f45c": {
    "sprite": "smileys",
    "x": 240,
    "y": 870
  },
  "1f4bc": {
    "sprite": "smileys",
    "x": 270,
    "y": 870
  },
  "1f392": {
    "sprite": "smileys",
    "x": 300,
    "y": 870
  },
  "1f9f3": {
    "sprite": "smileys",
    "x": 330,
    "y": 870
  },
  "1f453": {
    "sprite": "smileys",
    "x": 360,
    "y": 870
  },
  "1f576": {
    "sprite": "smileys",
    "x": 390,
    "y": 870
  },
  "1f97d": {
    "sprite": "smileys",
    "x": 420,
    "y": 870
  },
  "1f302": {
    "sprite": "smileys",
    "x": 450,
    "y": 870
  },
  "1f436": {
    "sprite": "natureza",
    "x": 0,
    "y": 0
  },
  "1f431": {
    "sprite": "natureza",
    "x": 30,
    "y": 0
  },
  "1f42d": {
    "sprite": "natureza",
    "x": 60,
    "y": 0
  },
  "1f439": {
    "sprite": "natureza",
    "x": 90,
    "y": 0
  },
  "1f430": {
    "sprite": "natureza",
    "x": 120,
    "y": 0
  },
  "1f98a": {
    "sprite": "natureza",
    "x": 150,
    "y": 0
  },
  "1f43b": {
    "sprite": "natureza",
    "x": 180,
    "y": 0
  },
  "1f43c": {
    "sprite": "natureza",
    "x": 210,
    "y": 0
  },
  "1f43b-200d-2744": {
    "sprite": "natureza",
    "x": 240,
    "y": 0
  },
  "1f428": {
    "sprite": "natureza",
    "x": 270,
    "y": 0
  },
  "1f42f": {
    "sprite": "natureza",
    "x": 300,
    "y": 0
  },
  "1f981": {
    "sprite": "natureza",
    "x": 330,
    "y": 0
  },
  "1f42e": {
    "sprite": "natureza",
    "x": 360,
    "y": 0
  },
  "1f437": {
    "sprite": "natureza",
    "x": 390,
    "y": 0
  },
  "1f43d": {
    "sprite": "natureza",
    "x": 420,
    "y": 0
  },
  "1f438": {
    "sprite": "natureza",
    "x": 450,
    "y": 0
  },
  "1f435": {
    "sprite": "natureza",
    "x": 0,
    "y": 30
  },
  "1f648": {
    "sprite": "natureza",
    "x": 30,
    "y": 30
  },
  "1f649": {
    "sprite": "natureza",
    "x": 60,
    "y": 30
  },
  "1f64a": {
    "sprite": "natureza",
    "x": 90,
    "y": 30
  },
  "1f412": {
    "sprite": "natureza",
    "x": 120,
    "y": 30
  },
  "1f414": {
    "sprite": "natureza",
    "x": 150,
    "y": 30
  },
  "1f427": {
    "sprite": "natureza",
    "x": 180,
    "y": 30
  },
  "1f426": {
    "sprite": "natureza",
    "x": 210,
    "y": 30
  },
  "1f424": {
    "sprite": "natureza",
    "x": 240,
    "y": 30
  },
  "1f423": {
    "sprite": "natureza",
    "x": 270,
    "y": 30
  },
  "1f425": {
    "sprite": "natureza",
    "x": 300,
    "y": 30
  },
  "1fabf": {
    "sprite": "natureza",
    "x": 330,
    "y": 30
  },
  "1f986": {
    "sprite": "natureza",
    "x": 360,
    "y": 30
  },
  "1f426-200d-2b1b": {
    "sprite": "natureza",
    "x": 390,
    "y": 30
  },
  "1f985": {
    "sprite": "natureza",
    "x": 420,
    "y": 30
  },
  "1f989": {
    "sprite": "natureza",
    "x": 450,
    "y": 30
  },
  "1f987": {
    "sprite": "natureza",
    "x": 0,
    "y": 60
  },
  "1f43a": {
    "sprite": "natureza",
    "x": 30,
    "y": 60
  },
  "1f417": {
    "sprite": "natureza",
    "x": 60,
    "y": 60
  },
  "1f434": {
    "sprite": "natureza",
    "x": 90,
    "y": 60
  },
  "1f984": {
    "sprite": "natureza",
    "x": 120,
    "y": 60
  },
  "1face": {
    "sprite": "natureza",
    "x": 150,
    "y": 60
  },
  "1f41d": {
    "sprite": "natureza",
    "x": 180,
    "y": 60
  },
  "1fab1": {
    "sprite": "natureza",
    "x": 210,
    "y": 60
  },
  "1f41b": {
    "sprite": "natureza",
    "x": 240,
    "y": 60
  },
  "1f98b": {
    "sprite": "natureza",
    "x": 270,
    "y": 60
  },
  "1f40c": {
    "sprite": "natureza",
    "x": 300,
    "y": 60
  },
  "1f41e": {
    "sprite": "natureza",
    "x": 330,
    "y": 60
  },
  "1f41c": {
    "sprite": "natureza",
    "x": 360,
    "y": 60
  },
  "1fab0": {
    "sprite": "natureza",
    "x": 390,
    "y": 60
  },
  "1fab2": {
    "sprite": "natureza",
    "x": 420,
    "y": 60
  },
  "1fab3": {
    "sprite": "natureza",
    "x": 450,
    "y": 60
  },
  "1f99f": {
    "sprite": "natureza",
    "x": 0,
    "y": 90
  },
  "1f997": {
    "sprite": "natureza",
    "x": 30,
    "y": 90
  },
  "1f577": {
    "sprite": "natureza",
    "x": 60,
    "y": 90
  },
  "1f578": {
    "sprite": "natureza",
    "x": 90,
    "y": 90
  },
  "1f982": {
    "sprite": "natureza",
    "x": 120,
    "y": 90
  },
  "1f422": {
    "sprite": "natureza",
    "x": 150,
    "y": 90
  },
  "1f40d": {
    "sprite": "natureza",
    "x": 180,
    "y": 90
  },
  "1f98e": {
    "sprite": "natureza",
    "x": 210,
    "y": 90
  },
  "1f996": {
    "sprite": "natureza",
    "x": 240,
    "y": 90
  },
  "1f995": {
    "sprite": "natureza",
    "x": 270,
    "y": 90
  },
  "1f419": {
    "sprite": "natureza",
    "x": 300,
    "y": 90
  },
  "1f991": {
    "sprite": "natureza",
    "x": 330,
    "y": 90
  },
  "1fabc": {
    "sprite": "natureza",
    "x": 360,
    "y": 90
  },
  "1f990": {
    "sprite": "natureza",
    "x": 390,
    "y": 90
  },
  "1f99e": {
    "sprite": "natureza",
    "x": 420,
    "y": 90
  },
  "1f980": {
    "sprite": "natureza",
    "x": 450,
    "y": 90
  },
  "1f421": {
    "sprite": "natureza",
    "x": 0,
    "y": 120
  },
  "1f420": {
    "sprite": "natureza",
    "x": 30,
    "y": 120
  },
  "1f41f": {
    "sprite": "natureza",
    "x": 60,
    "y": 120
  },
  "1f42c": {
    "sprite": "natureza",
    "x": 90,
    "y": 120
  },
  "1f433": {
    "sprite": "natureza",
    "x": 120,
    "y": 120
  },
  "1f40b": {
    "sprite": "natureza",
    "x": 150,
    "y": 120
  },
  "1f988": {
    "sprite": "natureza",
    "x": 180,
    "y": 120
  },
  "1f9ad": {
    "sprite": "natureza",
    "x": 210,
    "y": 120
  },
  "1f40a": {
    "sprite": "natureza",
    "x": 240,
    "y": 120
  },
  "1f405": {
    "sprite": "natureza",
    "x": 270,
    "y": 120
  },
  "1f406": {
    "sprite": "natureza",
    "x": 300,
    "y": 120
  },
  "1f993": {
    "sprite": "natureza",
    "x": 330,
    "y": 120
  },
  "1f98d": {
    "sprite": "natureza",
    "x": 360,
    "y": 120
  },
  "1f9a7": {
    "sprite": "natureza",
    "x": 390,
    "y": 120
  },
  "1f9a3": {
    "sprite": "natureza",
    "x": 420,
    "y": 120
  },
  "1f418": {
    "sprite": "natureza",
    "x": 450,
    "y": 120
  },
  "1f99b": {
    "sprite": "natureza",
    "x": 0,
    "y": 150
  },
  "1f98f": {
    "sprite": "natureza",
    "x": 30,
    "y": 150
  },
  "1f42a": {
    "sprite": "natureza",
    "x": 60,
    "y": 150
  },
  "1f42b": {
    "sprite": "natureza",
    "x": 90,
    "y": 150
  },
  "1f992": {
    "sprite": "natureza",
    "x": 120,
    "y": 150
  },
  "1f998": {
    "sprite": "natureza",
    "x": 150,
    "y": 150
  },
  "1f9ac": {
    "sprite": "natureza",
    "x": 180,
    "y": 150
  },
  "1f403": {
    "sprite": "natureza",
    "x": 210,
    "y": 150
  },
  "1f402": {
    "sprite": "natureza",
    "x": 240,
    "y": 150
  },
  "1f404": {
    "sprite": "natureza",
    "x": 270,
    "y": 150
  },
  "1facf": {
    "sprite": "natureza",
    "x": 300,
    "y": 150
  },
  "1f40e": {
    "sprite": "natureza",
    "x": 330,
    "y": 150
  },
  "1f416": {
    "sprite": "natureza",
    "x": 360,
    "y": 150
  },
  "1f40f": {
    "sprite": "natureza",
    "x": 390,
    "y": 150
  },
  "1f411": {
    "sprite": "natureza",
    "x": 420,
    "y": 150
  },
  "1f999": {
    "sprite": "natureza",
    "x": 450,
    "y": 150
  },
  "1f410": {
    "sprite": "natureza",
    "x": 0,
    "y": 180
  },
  "1f98c": {
    "sprite": "natureza",
    "x": 30,
    "y": 180
  },
  "1f415": {
    "sprite": "natureza",
    "x": 60,
    "y": 180
  },
  "1f429": {
    "sprite": "natureza",
    "x": 90,
    "y": 180
  },
  "1f9ae": {
    "sprite": "natureza",
    "x": 120,
    "y": 180
  },
  "1f415-200d-1f9ba": {
    "sprite": "natureza",
    "x": 150,
    "y": 180
  },
  "1f408": {
    "sprite": "natureza",
    "x": 180,
    "y": 180
  },
  "1f408-200d-2b1b": {
    "sprite": "natureza",
    "x": 210,
    "y": 180
  },
  "1fab6": {
    "sprite": "natureza",
    "x": 240,
    "y": 180
  },
  "1fabd": {
    "sprite": "natureza",
    "x": 270,
    "y": 180
  },
  "1f413": {
    "sprite": "natureza",
    "x": 300,
    "y": 180
  },
  "1f983": {
    "sprite": "natureza",
    "x": 330,
    "y": 180
  },
  "1f9a4": {
    "sprite": "natureza",
    "x": 360,
    "y": 180
  },
  "1f99a": {
    "sprite": "natureza",
    "x": 390,
    "y": 180
  },
  "1f99c": {
    "sprite": "natureza",
    "x": 420,
    "y": 180
  },
  "1f9a2": {
    "sprite": "natureza",
    "x": 450,
    "y": 180
  },
  "1f9a9": {
    "sprite": "natureza",
    "x": 0,
    "y": 210
  },
  "1f54a": {
    "sprite": "natureza",
    "x": 30,
    "y": 210
  },
  "1f407": {
    "sprite": "natureza",
    "x": 60,
    "y": 210
  },
  "1f99d": {
    "sprite": "natureza",
    "x": 90,
    "y": 210
  },
  "1f9a8": {
    "sprite": "natureza",
    "x": 120,
    "y": 210
  },
  "1f9a1": {
    "sprite": "natureza",
    "x": 150,
    "y": 210
  },
  "1f9ab": {
    "sprite": "natureza",
    "x": 180,
    "y": 210
  },
  "1f9a6": {
    "sprite": "natureza",
    "x": 210,
    "y": 210
  },
  "1f9a5": {
    "sprite": "natureza",
    "x": 240,
    "y": 210
  },
  "1f401": {
    "sprite": "natureza",
    "x": 270,
    "y": 210
  },
  "1f400": {
    "sprite": "natureza",
    "x": 300,
    "y": 210
  },
  "1f43f": {
    "sprite": "natureza",
    "x": 330,
    "y": 210
  },
  "1f994": {
    "sprite": "natureza",
    "x": 360,
    "y": 210
  },
  "1f43e": {
    "sprite": "natureza",
    "x": 390,
    "y": 210
  },
  "1f409": {
    "sprite": "natureza",
    "x": 420,
    "y": 210
  },
  "1f432": {
    "sprite": "natureza",
    "x": 450,
    "y": 210
  },
  "1f426-200d-1f525": {
    "sprite": "natureza",
    "x": 0,
    "y": 240
  },
  "1f335": {
    "sprite": "natureza",
    "x": 30,
    "y": 240
  },
  "1f384": {
    "sprite": "natureza",
    "x": 60,
    "y": 240
  },
  "1f332": {
    "sprite": "natureza",
    "x": 90,
    "y": 240
  },
  "1f333": {
    "sprite": "natureza",
    "x": 120,
    "y": 240
  },
  "1f334": {
    "sprite": "natureza",
    "x": 150,
    "y": 240
  },
  "1fabe": {
    "sprite": "natureza",
    "x": 180,
    "y": 240
  },
  "1fab5": {
    "sprite": "natureza",
    "x": 210,
    "y": 240
  },
  "1f331": {
    "sprite": "natureza",
    "x": 240,
    "y": 240
  },
  "1f33f": {
    "sprite": "natureza",
    "x": 270,
    "y": 240
  },
  "1f340": {
    "sprite": "natureza",
    "x": 330,
    "y": 240
  },
  "1f38d": {
    "sprite": "natureza",
    "x": 360,
    "y": 240
  },
  "1fab4": {
    "sprite": "natureza",
    "x": 390,
    "y": 240
  },
  "1f38b": {
    "sprite": "natureza",
    "x": 420,
    "y": 240
  },
  "1f343": {
    "sprite": "natureza",
    "x": 450,
    "y": 240
  },
  "1f342": {
    "sprite": "natureza",
    "x": 0,
    "y": 270
  },
  "1f341": {
    "sprite": "natureza",
    "x": 30,
    "y": 270
  },
  "1faba": {
    "sprite": "natureza",
    "x": 60,
    "y": 270
  },
  "1fab9": {
    "sprite": "natureza",
    "x": 90,
    "y": 270
  },
  "1f344": {
    "sprite": "natureza",
    "x": 120,
    "y": 270
  },
  "1f344-200d-1f7eb": {
    "sprite": "natureza",
    "x": 150,
    "y": 270
  },
  "1f41a": {
    "sprite": "natureza",
    "x": 180,
    "y": 270
  },
  "1fab8": {
    "sprite": "natureza",
    "x": 210,
    "y": 270
  },
  "1faa8": {
    "sprite": "natureza",
    "x": 240,
    "y": 270
  },
  "1f33e": {
    "sprite": "natureza",
    "x": 270,
    "y": 270
  },
  "1f490": {
    "sprite": "natureza",
    "x": 300,
    "y": 270
  },
  "1f337": {
    "sprite": "natureza",
    "x": 330,
    "y": 270
  },
  "1f339": {
    "sprite": "natureza",
    "x": 360,
    "y": 270
  },
  "1f940": {
    "sprite": "natureza",
    "x": 390,
    "y": 270
  },
  "1fabb": {
    "sprite": "natureza",
    "x": 420,
    "y": 270
  },
  "1fab7": {
    "sprite": "natureza",
    "x": 450,
    "y": 270
  },
  "1f33a": {
    "sprite": "natureza",
    "x": 0,
    "y": 300
  },
  "1f338": {
    "sprite": "natureza",
    "x": 30,
    "y": 300
  },
  "1f33c": {
    "sprite": "natureza",
    "x": 60,
    "y": 300
  },
  "1f33b": {
    "sprite": "natureza",
    "x": 90,
    "y": 300
  },
  "1f31e": {
    "sprite": "natureza",
    "x": 120,
    "y": 300
  },
  "1f31d": {
    "sprite": "natureza",
    "x": 150,
    "y": 300
  },
  "1f31b": {
    "sprite": "natureza",
    "x": 180,
    "y": 300
  },
  "1f31c": {
    "sprite": "natureza",
    "x": 210,
    "y": 300
  },
  "1f31a": {
    "sprite": "natureza",
    "x": 240,
    "y": 300
  },
  "1f315": {
    "sprite": "natureza",
    "x": 270,
    "y": 300
  },
  "1f316": {
    "sprite": "natureza",
    "x": 300,
    "y": 300
  },
  "1f317": {
    "sprite": "natureza",
    "x": 330,
    "y": 300
  },
  "1f318": {
    "sprite": "natureza",
    "x": 360,
    "y": 300
  },
  "1f311": {
    "sprite": "natureza",
    "x": 390,
    "y": 300
  },
  "1f312": {
    "sprite": "natureza",
    "x": 420,
    "y": 300
  },
  "1f313": {
    "sprite": "natureza",
    "x": 450,
    "y": 300
  },
  "1f314": {
    "sprite": "natureza",
    "x": 0,
    "y": 330
  },
  "1f319": {
    "sprite": "natureza",
    "x": 30,
    "y": 330
  },
  "1f30e": {
    "sprite": "natureza",
    "x": 60,
    "y": 330
  },
  "1f30d": {
    "sprite": "natureza",
    "x": 90,
    "y": 330
  },
  "1f30f": {
    "sprite": "natureza",
    "x": 120,
    "y": 330
  },
  "1fa90": {
    "sprite": "natureza",
    "x": 150,
    "y": 330
  },
  "1f4ab": {
    "sprite": "natureza",
    "x": 180,
    "y": 330
  },
  "2b50": {
    "sprite": "natureza",
    "x": 210,
    "y": 330
  },
  "1f31f": {
    "sprite": "natureza",
    "x": 240,
    "y": 330
  },
  "26a1": {
    "sprite": "natureza",
    "x": 300,
    "y": 330
  },
  "1f4a5": {
    "sprite": "natureza",
    "x": 360,
    "y": 330
  },
  "1f525": {
    "sprite": "natureza",
    "x": 390,
    "y": 330
  },
  "1f32a": {
    "sprite": "natureza",
    "x": 420,
    "y": 330
  },
  "1f308": {
    "sprite": "natureza",
    "x": 450,
    "y": 330
  },
  "1f324": {
    "sprite": "natureza",
    "x": 30,
    "y": 360
  },
  "26c5": {
    "sprite": "natureza",
    "x": 60,
    "y": 360
  },
  "1f325": {
    "sprite": "natureza",
    "x": 90,
    "y": 360
  },
  "1f326": {
    "sprite": "natureza",
    "x": 150,
    "y": 360
  },
  "1f327": {
    "sprite": "natureza",
    "x": 180,
    "y": 360
  },
  "26c8": {
    "sprite": "natureza",
    "x": 210,
    "y": 360
  },
  "1f329": {
    "sprite": "natureza",
    "x": 240,
    "y": 360
  },
  "1f328": {
    "sprite": "natureza",
    "x": 270,
    "y": 360
  },
  "26c4": {
    "sprite": "natureza",
    "x": 360,
    "y": 360
  },
  "1f32c": {
    "sprite": "natureza",
    "x": 390,
    "y": 360
  },
  "1f4a8": {
    "sprite": "natureza",
    "x": 420,
    "y": 360
  },
  "1f4a7": {
    "sprite": "natureza",
    "x": 450,
    "y": 360
  },
  "1f4a6": {
    "sprite": "natureza",
    "x": 0,
    "y": 390
  },
  "1fae7": {
    "sprite": "natureza",
    "x": 30,
    "y": 390
  },
  "1f30a": {
    "sprite": "natureza",
    "x": 120,
    "y": 390
  },
  "1f32b": {
    "sprite": "natureza",
    "x": 150,
    "y": 390
  },
  "1f34f": {
    "sprite": "comidas",
    "x": 0,
    "y": 0
  },
  "1f34e": {
    "sprite": "comidas",
    "x": 30,
    "y": 0
  },
  "1f350": {
    "sprite": "comidas",
    "x": 60,
    "y": 0
  },
  "1f34a": {
    "sprite": "comidas",
    "x": 90,
    "y": 0
  },
  "1f34b": {
    "sprite": "comidas",
    "x": 120,
    "y": 0
  },
  "1f34b-200d-1f7e9": {
    "sprite": "comidas",
    "x": 150,
    "y": 0
  },
  "1f34c": {
    "sprite": "comidas",
    "x": 180,
    "y": 0
  },
  "1f349": {
    "sprite": "comidas",
    "x": 210,
    "y": 0
  },
  "1f347": {
    "sprite": "comidas",
    "x": 240,
    "y": 0
  },
  "1f353": {
    "sprite": "comidas",
    "x": 270,
    "y": 0
  },
  "1fad0": {
    "sprite": "comidas",
    "x": 300,
    "y": 0
  },
  "1f348": {
    "sprite": "comidas",
    "x": 330,
    "y": 0
  },
  "1f352": {
    "sprite": "comidas",
    "x": 360,
    "y": 0
  },
  "1f351": {
    "sprite": "comidas",
    "x": 390,
    "y": 0
  },
  "1f96d": {
    "sprite": "comidas",
    "x": 420,
    "y": 0
  },
  "1f34d": {
    "sprite": "comidas",
    "x": 450,
    "y": 0
  },
  "1f965": {
    "sprite": "comidas",
    "x": 0,
    "y": 30
  },
  "1f95d": {
    "sprite": "comidas",
    "x": 30,
    "y": 30
  },
  "1f345": {
    "sprite": "comidas",
    "x": 60,
    "y": 30
  },
  "1f346": {
    "sprite": "comidas",
    "x": 90,
    "y": 30
  },
  "1f951": {
    "sprite": "comidas",
    "x": 120,
    "y": 30
  },
  "1fadb": {
    "sprite": "comidas",
    "x": 150,
    "y": 30
  },
  "1f966": {
    "sprite": "comidas",
    "x": 180,
    "y": 30
  },
  "1f96c": {
    "sprite": "comidas",
    "x": 210,
    "y": 30
  },
  "1f952": {
    "sprite": "comidas",
    "x": 240,
    "y": 30
  },
  "1f336": {
    "sprite": "comidas",
    "x": 270,
    "y": 30
  },
  "1fad1": {
    "sprite": "comidas",
    "x": 300,
    "y": 30
  },
  "1f33d": {
    "sprite": "comidas",
    "x": 330,
    "y": 30
  },
  "1f955": {
    "sprite": "comidas",
    "x": 360,
    "y": 30
  },
  "1fad2": {
    "sprite": "comidas",
    "x": 390,
    "y": 30
  },
  "1f9c4": {
    "sprite": "comidas",
    "x": 420,
    "y": 30
  },
  "1f9c5": {
    "sprite": "comidas",
    "x": 450,
    "y": 30
  },
  "1f954": {
    "sprite": "comidas",
    "x": 0,
    "y": 60
  },
  "1fadc": {
    "sprite": "comidas",
    "x": 30,
    "y": 60
  },
  "1f360": {
    "sprite": "comidas",
    "x": 60,
    "y": 60
  },
  "1fada": {
    "sprite": "comidas",
    "x": 90,
    "y": 60
  },
  "1f950": {
    "sprite": "comidas",
    "x": 120,
    "y": 60
  },
  "1f96f": {
    "sprite": "comidas",
    "x": 150,
    "y": 60
  },
  "1f35e": {
    "sprite": "comidas",
    "x": 180,
    "y": 60
  },
  "1f956": {
    "sprite": "comidas",
    "x": 210,
    "y": 60
  },
  "1f968": {
    "sprite": "comidas",
    "x": 240,
    "y": 60
  },
  "1f9c0": {
    "sprite": "comidas",
    "x": 270,
    "y": 60
  },
  "1f95a": {
    "sprite": "comidas",
    "x": 300,
    "y": 60
  },
  "1f373": {
    "sprite": "comidas",
    "x": 330,
    "y": 60
  },
  "1f9c8": {
    "sprite": "comidas",
    "x": 360,
    "y": 60
  },
  "1f95e": {
    "sprite": "comidas",
    "x": 390,
    "y": 60
  },
  "1f9c7": {
    "sprite": "comidas",
    "x": 420,
    "y": 60
  },
  "1f953": {
    "sprite": "comidas",
    "x": 450,
    "y": 60
  },
  "1f969": {
    "sprite": "comidas",
    "x": 0,
    "y": 90
  },
  "1f357": {
    "sprite": "comidas",
    "x": 30,
    "y": 90
  },
  "1f356": {
    "sprite": "comidas",
    "x": 60,
    "y": 90
  },
  "1f9b4": {
    "sprite": "comidas",
    "x": 90,
    "y": 90
  },
  "1f32d": {
    "sprite": "comidas",
    "x": 120,
    "y": 90
  },
  "1f354": {
    "sprite": "comidas",
    "x": 150,
    "y": 90
  },
  "1f35f": {
    "sprite": "comidas",
    "x": 180,
    "y": 90
  },
  "1f355": {
    "sprite": "comidas",
    "x": 210,
    "y": 90
  },
  "1fad3": {
    "sprite": "comidas",
    "x": 240,
    "y": 90
  },
  "1f96a": {
    "sprite": "comidas",
    "x": 270,
    "y": 90
  },
  "1f959": {
    "sprite": "comidas",
    "x": 300,
    "y": 90
  },
  "1f9c6": {
    "sprite": "comidas",
    "x": 330,
    "y": 90
  },
  "1f32e": {
    "sprite": "comidas",
    "x": 360,
    "y": 90
  },
  "1f32f": {
    "sprite": "comidas",
    "x": 390,
    "y": 90
  },
  "1fad4": {
    "sprite": "comidas",
    "x": 420,
    "y": 90
  },
  "1f957": {
    "sprite": "comidas",
    "x": 450,
    "y": 90
  },
  "1f958": {
    "sprite": "comidas",
    "x": 0,
    "y": 120
  },
  "1fad5": {
    "sprite": "comidas",
    "x": 30,
    "y": 120
  },
  "1f96b": {
    "sprite": "comidas",
    "x": 60,
    "y": 120
  },
  "1fad9": {
    "sprite": "comidas",
    "x": 90,
    "y": 120
  },
  "1f35d": {
    "sprite": "comidas",
    "x": 120,
    "y": 120
  },
  "1f35c": {
    "sprite": "comidas",
    "x": 150,
    "y": 120
  },
  "1f372": {
    "sprite": "comidas",
    "x": 180,
    "y": 120
  },
  "1f35b": {
    "sprite": "comidas",
    "x": 210,
    "y": 120
  },
  "1f363": {
    "sprite": "comidas",
    "x": 240,
    "y": 120
  },
  "1f371": {
    "sprite": "comidas",
    "x": 270,
    "y": 120
  },
  "1f95f": {
    "sprite": "comidas",
    "x": 300,
    "y": 120
  },
  "1f9aa": {
    "sprite": "comidas",
    "x": 330,
    "y": 120
  },
  "1f364": {
    "sprite": "comidas",
    "x": 360,
    "y": 120
  },
  "1f359": {
    "sprite": "comidas",
    "x": 390,
    "y": 120
  },
  "1f35a": {
    "sprite": "comidas",
    "x": 420,
    "y": 120
  },
  "1f358": {
    "sprite": "comidas",
    "x": 450,
    "y": 120
  },
  "1f365": {
    "sprite": "comidas",
    "x": 0,
    "y": 150
  },
  "1f960": {
    "sprite": "comidas",
    "x": 30,
    "y": 150
  },
  "1f96e": {
    "sprite": "comidas",
    "x": 60,
    "y": 150
  },
  "1f362": {
    "sprite": "comidas",
    "x": 90,
    "y": 150
  },
  "1f361": {
    "sprite": "comidas",
    "x": 120,
    "y": 150
  },
  "1f367": {
    "sprite": "comidas",
    "x": 150,
    "y": 150
  },
  "1f368": {
    "sprite": "comidas",
    "x": 180,
    "y": 150
  },
  "1f366": {
    "sprite": "comidas",
    "x": 210,
    "y": 150
  },
  "1f967": {
    "sprite": "comidas",
    "x": 240,
    "y": 150
  },
  "1f9c1": {
    "sprite": "comidas",
    "x": 270,
    "y": 150
  },
  "1f370": {
    "sprite": "comidas",
    "x": 300,
    "y": 150
  },
  "1f382": {
    "sprite": "comidas",
    "x": 330,
    "y": 150
  },
  "1f36e": {
    "sprite": "comidas",
    "x": 360,
    "y": 150
  },
  "1f36d": {
    "sprite": "comidas",
    "x": 390,
    "y": 150
  },
  "1f36c": {
    "sprite": "comidas",
    "x": 420,
    "y": 150
  },
  "1f36b": {
    "sprite": "comidas",
    "x": 450,
    "y": 150
  },
  "1f37f": {
    "sprite": "comidas",
    "x": 0,
    "y": 180
  },
  "1f369": {
    "sprite": "comidas",
    "x": 30,
    "y": 180
  },
  "1f36a": {
    "sprite": "comidas",
    "x": 60,
    "y": 180
  },
  "1f330": {
    "sprite": "comidas",
    "x": 90,
    "y": 180
  },
  "1f95c": {
    "sprite": "comidas",
    "x": 120,
    "y": 180
  },
  "1fad8": {
    "sprite": "comidas",
    "x": 150,
    "y": 180
  },
  "1f36f": {
    "sprite": "comidas",
    "x": 180,
    "y": 180
  },
  "1f95b": {
    "sprite": "comidas",
    "x": 210,
    "y": 180
  },
  "1fad7": {
    "sprite": "comidas",
    "x": 240,
    "y": 180
  },
  "1f37c": {
    "sprite": "comidas",
    "x": 270,
    "y": 180
  },
  "1fad6": {
    "sprite": "comidas",
    "x": 300,
    "y": 180
  },
  "1f375": {
    "sprite": "comidas",
    "x": 360,
    "y": 180
  },
  "1f9c3": {
    "sprite": "comidas",
    "x": 390,
    "y": 180
  },
  "1f964": {
    "sprite": "comidas",
    "x": 420,
    "y": 180
  },
  "1f9cb": {
    "sprite": "comidas",
    "x": 450,
    "y": 180
  },
  "1f376": {
    "sprite": "comidas",
    "x": 0,
    "y": 210
  },
  "1f37a": {
    "sprite": "comidas",
    "x": 30,
    "y": 210
  },
  "1f37b": {
    "sprite": "comidas",
    "x": 60,
    "y": 210
  },
  "1f942": {
    "sprite": "comidas",
    "x": 90,
    "y": 210
  },
  "1f377": {
    "sprite": "comidas",
    "x": 120,
    "y": 210
  },
  "1f943": {
    "sprite": "comidas",
    "x": 150,
    "y": 210
  },
  "1f378": {
    "sprite": "comidas",
    "x": 180,
    "y": 210
  },
  "1f379": {
    "sprite": "comidas",
    "x": 210,
    "y": 210
  },
  "1f9c9": {
    "sprite": "comidas",
    "x": 240,
    "y": 210
  },
  "1f37e": {
    "sprite": "comidas",
    "x": 270,
    "y": 210
  },
  "1f9ca": {
    "sprite": "comidas",
    "x": 300,
    "y": 210
  },
  "1f944": {
    "sprite": "comidas",
    "x": 330,
    "y": 210
  },
  "1f374": {
    "sprite": "comidas",
    "x": 360,
    "y": 210
  },
  "1f37d": {
    "sprite": "comidas",
    "x": 390,
    "y": 210
  },
  "1f963": {
    "sprite": "comidas",
    "x": 420,
    "y": 210
  },
  "1f961": {
    "sprite": "comidas",
    "x": 450,
    "y": 210
  },
  "1f962": {
    "sprite": "comidas",
    "x": 0,
    "y": 240
  },
  "1f9c2": {
    "sprite": "comidas",
    "x": 30,
    "y": 240
  },
  "26bd": {
    "sprite": "atividades",
    "x": 0,
    "y": 0
  },
  "1f3c0": {
    "sprite": "atividades",
    "x": 30,
    "y": 0
  },
  "1f3c8": {
    "sprite": "atividades",
    "x": 60,
    "y": 0
  },
  "26be": {
    "sprite": "atividades",
    "x": 90,
    "y": 0
  },
  "1f94e": {
    "sprite": "atividades",
    "x": 120,
    "y": 0
  },
  "1f3be": {
    "sprite": "atividades",
    "x": 150,
    "y": 0
  },
  "1f3d0": {
    "sprite": "atividades",
    "x": 180,
    "y": 0
  },
  "1f3c9": {
    "sprite": "atividades",
    "x": 210,
    "y": 0
  },
  "1f94f": {
    "sprite": "atividades",
    "x": 240,
    "y": 0
  },
  "1f3b1": {
    "sprite": "atividades",
    "x": 270,
    "y": 0
  },
  "1fa80": {
    "sprite": "atividades",
    "x": 300,
    "y": 0
  },
  "1f3d3": {
    "sprite": "atividades",
    "x": 330,
    "y": 0
  },
  "1f3f8": {
    "sprite": "atividades",
    "x": 360,
    "y": 0
  },
  "1f3d2": {
    "sprite": "atividades",
    "x": 390,
    "y": 0
  },
  "1f3d1": {
    "sprite": "atividades",
    "x": 420,
    "y": 0
  },
  "1f94d": {
    "sprite": "atividades",
    "x": 450,
    "y": 0
  },
  "1f3cf": {
    "sprite": "atividades",
    "x": 0,
    "y": 30
  },
  "1fa83": {
    "sprite": "atividades",
    "x": 30,
    "y": 30
  },
  "1f945": {
    "sprite": "atividades",
    "x": 60,
    "y": 30
  },
  "26f3": {
    "sprite": "atividades",
    "x": 90,
    "y": 30
  },
  "1fa81": {
    "sprite": "atividades",
    "x": 120,
    "y": 30
  },
  "1f6dd": {
    "sprite": "atividades",
    "x": 150,
    "y": 30
  },
  "1f3f9": {
    "sprite": "atividades",
    "x": 180,
    "y": 30
  },
  "1f3a3": {
    "sprite": "atividades",
    "x": 210,
    "y": 30
  },
  "1f93f": {
    "sprite": "atividades",
    "x": 240,
    "y": 30
  },
  "1f94a": {
    "sprite": "atividades",
    "x": 270,
    "y": 30
  },
  "1f94b": {
    "sprite": "atividades",
    "x": 300,
    "y": 30
  },
  "1f3bd": {
    "sprite": "atividades",
    "x": 330,
    "y": 30
  },
  "1f6f9": {
    "sprite": "atividades",
    "x": 360,
    "y": 30
  },
  "1f6fc": {
    "sprite": "atividades",
    "x": 390,
    "y": 30
  },
  "1f6f7": {
    "sprite": "atividades",
    "x": 420,
    "y": 30
  },
  "26f8": {
    "sprite": "atividades",
    "x": 450,
    "y": 30
  },
  "1f94c": {
    "sprite": "atividades",
    "x": 0,
    "y": 60
  },
  "1f3bf": {
    "sprite": "atividades",
    "x": 30,
    "y": 60
  },
  "26f7": {
    "sprite": "atividades",
    "x": 60,
    "y": 60
  },
  "1f3c2": {
    "sprite": "atividades",
    "x": 90,
    "y": 60
  },
  "1fa82": {
    "sprite": "atividades",
    "x": 120,
    "y": 60
  },
  "1f3cb-200d-2640": {
    "sprite": "atividades",
    "x": 150,
    "y": 60
  },
  "1f3cb": {
    "sprite": "atividades",
    "x": 180,
    "y": 60
  },
  "1f3cb-200d-2642": {
    "sprite": "atividades",
    "x": 210,
    "y": 60
  },
  "1f93c-200d-2640": {
    "sprite": "atividades",
    "x": 240,
    "y": 60
  },
  "1f93c": {
    "sprite": "atividades",
    "x": 270,
    "y": 60
  },
  "1f93c-200d-2642": {
    "sprite": "atividades",
    "x": 300,
    "y": 60
  },
  "1f938-200d-2640": {
    "sprite": "atividades",
    "x": 330,
    "y": 60
  },
  "1f938": {
    "sprite": "atividades",
    "x": 360,
    "y": 60
  },
  "1f938-200d-2642": {
    "sprite": "atividades",
    "x": 390,
    "y": 60
  },
  "26f9-200d-2640": {
    "sprite": "atividades",
    "x": 420,
    "y": 60
  },
  "26f9": {
    "sprite": "atividades",
    "x": 450,
    "y": 60
  },
  "26f9-200d-2642": {
    "sprite": "atividades",
    "x": 0,
    "y": 90
  },
  "1f93a": {
    "sprite": "atividades",
    "x": 30,
    "y": 90
  },
  "1f93e-200d-2640": {
    "sprite": "atividades",
    "x": 60,
    "y": 90
  },
  "1f93e": {
    "sprite": "atividades",
    "x": 90,
    "y": 90
  },
  "1f93e-200d-2642": {
    "sprite": "atividades",
    "x": 120,
    "y": 90
  },
  "1f3cc-200d-2640": {
    "sprite": "atividades",
    "x": 150,
    "y": 90
  },
  "1f3cc": {
    "sprite": "atividades",
    "x": 180,
    "y": 90
  },
  "1f3cc-200d-2642": {
    "sprite": "atividades",
    "x": 210,
    "y": 90
  },
  "1f3c7": {
    "sprite": "atividades",
    "x": 240,
    "y": 90
  },
  "1f9d8-200d-2640": {
    "sprite": "atividades",
    "x": 270,
    "y": 90
  },
  "1f9d8": {
    "sprite": "atividades",
    "x": 300,
    "y": 90
  },
  "1f9d8-200d-2642": {
    "sprite": "atividades",
    "x": 330,
    "y": 90
  },
  "1f3c4-200d-2640": {
    "sprite": "atividades",
    "x": 360,
    "y": 90
  },
  "1f3c4": {
    "sprite": "atividades",
    "x": 390,
    "y": 90
  },
  "1f3c4-200d-2642": {
    "sprite": "atividades",
    "x": 420,
    "y": 90
  },
  "1f3ca-200d-2640": {
    "sprite": "atividades",
    "x": 450,
    "y": 90
  },
  "1f3ca": {
    "sprite": "atividades",
    "x": 0,
    "y": 120
  },
  "1f3ca-200d-2642": {
    "sprite": "atividades",
    "x": 30,
    "y": 120
  },
  "1f93d-200d-2640": {
    "sprite": "atividades",
    "x": 60,
    "y": 120
  },
  "1f93d": {
    "sprite": "atividades",
    "x": 90,
    "y": 120
  },
  "1f93d-200d-2642": {
    "sprite": "atividades",
    "x": 120,
    "y": 120
  },
  "1f6a3-200d-2640": {
    "sprite": "atividades",
    "x": 150,
    "y": 120
  },
  "1f6a3": {
    "sprite": "atividades",
    "x": 180,
    "y": 120
  },
  "1f6a3-200d-2642": {
    "sprite": "atividades",
    "x": 210,
    "y": 120
  },
  "1f9d7-200d-2640": {
    "sprite": "atividades",
    "x": 240,
    "y": 120
  },
  "1f9d7": {
    "sprite": "atividades",
    "x": 270,
    "y": 120
  },
  "1f9d7-200d-2642": {
    "sprite": "atividades",
    "x": 300,
    "y": 120
  },
  "1f6b5-200d-2640": {
    "sprite": "atividades",
    "x": 330,
    "y": 120
  },
  "1f6b5": {
    "sprite": "atividades",
    "x": 360,
    "y": 120
  },
  "1f6b5-200d-2642": {
    "sprite": "atividades",
    "x": 390,
    "y": 120
  },
  "1f6b4-200d-2640": {
    "sprite": "atividades",
    "x": 420,
    "y": 120
  },
  "1f6b4": {
    "sprite": "atividades",
    "x": 450,
    "y": 120
  },
  "1f6b4-200d-2642": {
    "sprite": "atividades",
    "x": 0,
    "y": 150
  },
  "1f3c6": {
    "sprite": "atividades",
    "x": 30,
    "y": 150
  },
  "1f947": {
    "sprite": "atividades",
    "x": 60,
    "y": 150
  },
  "1f948": {
    "sprite": "atividades",
    "x": 90,
    "y": 150
  },
  "1f949": {
    "sprite": "atividades",
    "x": 120,
    "y": 150
  },
  "1f3c5": {
    "sprite": "atividades",
    "x": 150,
    "y": 150
  },
  "1f396": {
    "sprite": "atividades",
    "x": 180,
    "y": 150
  },
  "1f3f5": {
    "sprite": "atividades",
    "x": 210,
    "y": 150
  },
  "1f397": {
    "sprite": "atividades",
    "x": 240,
    "y": 150
  },
  "1f3ab": {
    "sprite": "atividades",
    "x": 270,
    "y": 150
  },
  "1f39f": {
    "sprite": "atividades",
    "x": 300,
    "y": 150
  },
  "1f3aa": {
    "sprite": "atividades",
    "x": 330,
    "y": 150
  },
  "1f939-200d-2640": {
    "sprite": "atividades",
    "x": 360,
    "y": 150
  },
  "1f939": {
    "sprite": "atividades",
    "x": 390,
    "y": 150
  },
  "1f939-200d-2642": {
    "sprite": "atividades",
    "x": 420,
    "y": 150
  },
  "1f3ad": {
    "sprite": "atividades",
    "x": 450,
    "y": 150
  },
  "1fa70": {
    "sprite": "atividades",
    "x": 0,
    "y": 180
  },
  "1f3a8": {
    "sprite": "atividades",
    "x": 30,
    "y": 180
  },
  "1fadf": {
    "sprite": "atividades",
    "x": 60,
    "y": 180
  },
  "1f3ac": {
    "sprite": "atividades",
    "x": 90,
    "y": 180
  },
  "1f3a4": {
    "sprite": "atividades",
    "x": 120,
    "y": 180
  },
  "1f3a7": {
    "sprite": "atividades",
    "x": 150,
    "y": 180
  },
  "1f3bc": {
    "sprite": "atividades",
    "x": 180,
    "y": 180
  },
  "1f3b9": {
    "sprite": "atividades",
    "x": 210,
    "y": 180
  },
  "1fa87": {
    "sprite": "atividades",
    "x": 240,
    "y": 180
  },
  "1f941": {
    "sprite": "atividades",
    "x": 270,
    "y": 180
  },
  "1fa98": {
    "sprite": "atividades",
    "x": 300,
    "y": 180
  },
  "1f3b7": {
    "sprite": "atividades",
    "x": 330,
    "y": 180
  },
  "1f3ba": {
    "sprite": "atividades",
    "x": 360,
    "y": 180
  },
  "1fa97": {
    "sprite": "atividades",
    "x": 390,
    "y": 180
  },
  "1f3b8": {
    "sprite": "atividades",
    "x": 420,
    "y": 180
  },
  "1fa95": {
    "sprite": "atividades",
    "x": 450,
    "y": 180
  },
  "1fa89": {
    "sprite": "atividades",
    "x": 0,
    "y": 210
  },
  "1f3bb": {
    "sprite": "atividades",
    "x": 30,
    "y": 210
  },
  "1fa88": {
    "sprite": "atividades",
    "x": 60,
    "y": 210
  },
  "1f3b2": {
    "sprite": "atividades",
    "x": 90,
    "y": 210
  },
  "265f": {
    "sprite": "atividades",
    "x": 120,
    "y": 210
  },
  "1f3af": {
    "sprite": "atividades",
    "x": 150,
    "y": 210
  },
  "1f3b3": {
    "sprite": "atividades",
    "x": 180,
    "y": 210
  },
  "1f3ae": {
    "sprite": "atividades",
    "x": 210,
    "y": 210
  },
  "1f3b0": {
    "sprite": "atividades",
    "x": 240,
    "y": 210
  },
  "1f9e9": {
    "sprite": "atividades",
    "x": 270,
    "y": 210
  },
  "1f697": {
    "sprite": "viagens",
    "x": 0,
    "y": 0
  },
  "1f695": {
    "sprite": "viagens",
    "x": 30,
    "y": 0
  },
  "1f699": {
    "sprite": "viagens",
    "x": 60,
    "y": 0
  },
  "1f68c": {
    "sprite": "viagens",
    "x": 90,
    "y": 0
  },
  "1f68e": {
    "sprite": "viagens",
    "x": 120,
    "y": 0
  },
  "1f3ce": {
    "sprite": "viagens",
    "x": 150,
    "y": 0
  },
  "1f693": {
    "sprite": "viagens",
    "x": 180,
    "y": 0
  },
  "1f691": {
    "sprite": "viagens",
    "x": 210,
    "y": 0
  },
  "1f692": {
    "sprite": "viagens",
    "x": 240,
    "y": 0
  },
  "1f690": {
    "sprite": "viagens",
    "x": 270,
    "y": 0
  },
  "1f6fb": {
    "sprite": "viagens",
    "x": 300,
    "y": 0
  },
  "1f69a": {
    "sprite": "viagens",
    "x": 330,
    "y": 0
  },
  "1f69b": {
    "sprite": "viagens",
    "x": 360,
    "y": 0
  },
  "1f69c": {
    "sprite": "viagens",
    "x": 390,
    "y": 0
  },
  "1f9af": {
    "sprite": "viagens",
    "x": 420,
    "y": 0
  },
  "1f9bd": {
    "sprite": "viagens",
    "x": 450,
    "y": 0
  },
  "1f9bc": {
    "sprite": "viagens",
    "x": 0,
    "y": 30
  },
  "1fa7c": {
    "sprite": "viagens",
    "x": 30,
    "y": 30
  },
  "1f6f4": {
    "sprite": "viagens",
    "x": 60,
    "y": 30
  },
  "1f6b2": {
    "sprite": "viagens",
    "x": 90,
    "y": 30
  },
  "1f6f5": {
    "sprite": "viagens",
    "x": 120,
    "y": 30
  },
  "1f3cd": {
    "sprite": "viagens",
    "x": 150,
    "y": 30
  },
  "1f6fa": {
    "sprite": "viagens",
    "x": 180,
    "y": 30
  },
  "1f6de": {
    "sprite": "viagens",
    "x": 210,
    "y": 30
  },
  "1f6a8": {
    "sprite": "viagens",
    "x": 240,
    "y": 30
  },
  "1f694": {
    "sprite": "viagens",
    "x": 270,
    "y": 30
  },
  "1f68d": {
    "sprite": "viagens",
    "x": 300,
    "y": 30
  },
  "1f698": {
    "sprite": "viagens",
    "x": 330,
    "y": 30
  },
  "1f696": {
    "sprite": "viagens",
    "x": 360,
    "y": 30
  },
  "1f6a1": {
    "sprite": "viagens",
    "x": 390,
    "y": 30
  },
  "1f6a0": {
    "sprite": "viagens",
    "x": 420,
    "y": 30
  },
  "1f69f": {
    "sprite": "viagens",
    "x": 450,
    "y": 30
  },
  "1f683": {
    "sprite": "viagens",
    "x": 0,
    "y": 60
  },
  "1f68b": {
    "sprite": "viagens",
    "x": 30,
    "y": 60
  },
  "1f69e": {
    "sprite": "viagens",
    "x": 60,
    "y": 60
  },
  "1f69d": {
    "sprite": "viagens",
    "x": 90,
    "y": 60
  },
  "1f684": {
    "sprite": "viagens",
    "x": 120,
    "y": 60
  },
  "1f685": {
    "sprite": "viagens",
    "x": 150,
    "y": 60
  },
  "1f688": {
    "sprite": "viagens",
    "x": 180,
    "y": 60
  },
  "1f682": {
    "sprite": "viagens",
    "x": 210,
    "y": 60
  },
  "1f686": {
    "sprite": "viagens",
    "x": 240,
    "y": 60
  },
  "1f687": {
    "sprite": "viagens",
    "x": 270,
    "y": 60
  },
  "1f68a": {
    "sprite": "viagens",
    "x": 300,
    "y": 60
  },
  "1f689": {
    "sprite": "viagens",
    "x": 330,
    "y": 60
  },
  "1f6eb": {
    "sprite": "viagens",
    "x": 390,
    "y": 60
  },
  "1f6ec": {
    "sprite": "viagens",
    "x": 420,
    "y": 60
  },
  "1f6e9": {
    "sprite": "viagens",
    "x": 450,
    "y": 60
  },
  "1f4ba": {
    "sprite": "viagens",
    "x": 0,
    "y": 90
  },
  "1f6f0": {
    "sprite": "viagens",
    "x": 30,
    "y": 90
  },
  "1f680": {
    "sprite": "viagens",
    "x": 60,
    "y": 90
  },
  "1f6f8": {
    "sprite": "viagens",
    "x": 90,
    "y": 90
  },
  "1f681": {
    "sprite": "viagens",
    "x": 120,
    "y": 90
  },
  "1f6f6": {
    "sprite": "viagens",
    "x": 150,
    "y": 90
  },
  "26f5": {
    "sprite": "viagens",
    "x": 180,
    "y": 90
  },
  "1f6a4": {
    "sprite": "viagens",
    "x": 210,
    "y": 90
  },
  "1f6e5": {
    "sprite": "viagens",
    "x": 240,
    "y": 90
  },
  "1f6f3": {
    "sprite": "viagens",
    "x": 270,
    "y": 90
  },
  "26f4": {
    "sprite": "viagens",
    "x": 300,
    "y": 90
  },
  "1f6a2": {
    "sprite": "viagens",
    "x": 330,
    "y": 90
  },
  "1f6df": {
    "sprite": "viagens",
    "x": 360,
    "y": 90
  },
  "1fa9d": {
    "sprite": "viagens",
    "x": 420,
    "y": 90
  },
  "26fd": {
    "sprite": "viagens",
    "x": 450,
    "y": 90
  },
  "1f6a7": {
    "sprite": "viagens",
    "x": 0,
    "y": 120
  },
  "1f6a6": {
    "sprite": "viagens",
    "x": 30,
    "y": 120
  },
  "1f6a5": {
    "sprite": "viagens",
    "x": 60,
    "y": 120
  },
  "1f68f": {
    "sprite": "viagens",
    "x": 90,
    "y": 120
  },
  "1f5fa": {
    "sprite": "viagens",
    "x": 120,
    "y": 120
  },
  "1f5ff": {
    "sprite": "viagens",
    "x": 150,
    "y": 120
  },
  "1f5fd": {
    "sprite": "viagens",
    "x": 180,
    "y": 120
  },
  "1f5fc": {
    "sprite": "viagens",
    "x": 210,
    "y": 120
  },
  "1f3f0": {
    "sprite": "viagens",
    "x": 240,
    "y": 120
  },
  "1f3ef": {
    "sprite": "viagens",
    "x": 270,
    "y": 120
  },
  "1f3df": {
    "sprite": "viagens",
    "x": 300,
    "y": 120
  },
  "1f3a1": {
    "sprite": "viagens",
    "x": 330,
    "y": 120
  },
  "1f3a2": {
    "sprite": "viagens",
    "x": 360,
    "y": 120
  },
  "1f3a0": {
    "sprite": "viagens",
    "x": 390,
    "y": 120
  },
  "26f2": {
    "sprite": "viagens",
    "x": 420,
    "y": 120
  },
  "26f1": {
    "sprite": "viagens",
    "x": 450,
    "y": 120
  },
  "1f3d6": {
    "sprite": "viagens",
    "x": 0,
    "y": 150
  },
  "1f3dd": {
    "sprite": "viagens",
    "x": 30,
    "y": 150
  },
  "1f3dc": {
    "sprite": "viagens",
    "x": 60,
    "y": 150
  },
  "1f30b": {
    "sprite": "viagens",
    "x": 90,
    "y": 150
  },
  "26f0": {
    "sprite": "viagens",
    "x": 120,
    "y": 150
  },
  "1f3d4": {
    "sprite": "viagens",
    "x": 150,
    "y": 150
  },
  "1f5fb": {
    "sprite": "viagens",
    "x": 180,
    "y": 150
  },
  "1f3d5": {
    "sprite": "viagens",
    "x": 210,
    "y": 150
  },
  "26fa": {
    "sprite": "viagens",
    "x": 240,
    "y": 150
  },
  "1f6d6": {
    "sprite": "viagens",
    "x": 270,
    "y": 150
  },
  "1f3e0": {
    "sprite": "viagens",
    "x": 300,
    "y": 150
  },
  "1f3e1": {
    "sprite": "viagens",
    "x": 330,
    "y": 150
  },
  "1f3d8": {
    "sprite": "viagens",
    "x": 360,
    "y": 150
  },
  "1f3da": {
    "sprite": "viagens",
    "x": 390,
    "y": 150
  },
  "1f3d7": {
    "sprite": "viagens",
    "x": 420,
    "y": 150
  },
  "1f3ed": {
    "sprite": "viagens",
    "x": 450,
    "y": 150
  },
  "1f3e2": {
    "sprite": "viagens",
    "x": 0,
    "y": 180
  },
  "1f3ec": {
    "sprite": "viagens",
    "x": 30,
    "y": 180
  },
  "1f3e3": {
    "sprite": "viagens",
    "x": 60,
    "y": 180
  },
  "1f3e4": {
    "sprite": "viagens",
    "x": 90,
    "y": 180
  },
  "1f3e5": {
    "sprite": "viagens",
    "x": 120,
    "y": 180
  },
  "1f3e6": {
    "sprite": "viagens",
    "x": 150,
    "y": 180
  },
  "1f3e8": {
    "sprite": "viagens",
    "x": 180,
    "y": 180
  },
  "1f3ea": {
    "sprite": "viagens",
    "x": 210,
    "y": 180
  },
  "1f3eb": {
    "sprite": "viagens",
    "x": 240,
    "y": 180
  },
  "1f3e9": {
    "sprite": "viagens",
    "x": 270,
    "y": 180
  },
  "1f492": {
    "sprite": "viagens",
    "x": 300,
    "y": 180
  },
  "1f3db": {
    "sprite": "viagens",
    "x": 330,
    "y": 180
  },
  "26ea": {
    "sprite": "viagens",
    "x": 360,
    "y": 180
  },
  "1f54c": {
    "sprite": "viagens",
    "x": 390,
    "y": 180
  },
  "1f54d": {
    "sprite": "viagens",
    "x": 420,
    "y": 180
  },
  "1f6d5": {
    "sprite": "viagens",
    "x": 450,
    "y": 180
  },
  "1f54b": {
    "sprite": "viagens",
    "x": 0,
    "y": 210
  },
  "26e9": {
    "sprite": "viagens",
    "x": 30,
    "y": 210
  },
  "1f6e4": {
    "sprite": "viagens",
    "x": 60,
    "y": 210
  },
  "1f6e3": {
    "sprite": "viagens",
    "x": 90,
    "y": 210
  },
  "1f5fe": {
    "sprite": "viagens",
    "x": 120,
    "y": 210
  },
  "1f391": {
    "sprite": "viagens",
    "x": 150,
    "y": 210
  },
  "1f3de": {
    "sprite": "viagens",
    "x": 180,
    "y": 210
  },
  "1f305": {
    "sprite": "viagens",
    "x": 210,
    "y": 210
  },
  "1f304": {
    "sprite": "viagens",
    "x": 240,
    "y": 210
  },
  "1f320": {
    "sprite": "viagens",
    "x": 270,
    "y": 210
  },
  "1f387": {
    "sprite": "viagens",
    "x": 300,
    "y": 210
  },
  "1f386": {
    "sprite": "viagens",
    "x": 330,
    "y": 210
  },
  "1f307": {
    "sprite": "viagens",
    "x": 360,
    "y": 210
  },
  "1f306": {
    "sprite": "viagens",
    "x": 390,
    "y": 210
  },
  "1f3d9": {
    "sprite": "viagens",
    "x": 420,
    "y": 210
  },
  "1f303": {
    "sprite": "viagens",
    "x": 450,
    "y": 210
  },
  "1f30c": {
    "sprite": "viagens",
    "x": 0,
    "y": 240
  },
  "1f309": {
    "sprite": "viagens",
    "x": 30,
    "y": 240
  },
  "1f301": {
    "sprite": "viagens",
    "x": 60,
    "y": 240
  },
  "231a": {
    "sprite": "objetos",
    "x": 0,
    "y": 0
  },
  "1f4f1": {
    "sprite": "objetos",
    "x": 30,
    "y": 0
  },
  "1f4f2": {
    "sprite": "objetos",
    "x": 60,
    "y": 0
  },
  "1f4bb": {
    "sprite": "objetos",
    "x": 90,
    "y": 0
  },
  "1f5a5": {
    "sprite": "objetos",
    "x": 150,
    "y": 0
  },
  "1f5a8": {
    "sprite": "objetos",
    "x": 180,
    "y": 0
  },
  "1f5b1": {
    "sprite": "objetos",
    "x": 210,
    "y": 0
  },
  "1f5b2": {
    "sprite": "objetos",
    "x": 240,
    "y": 0
  },
  "1f579": {
    "sprite": "objetos",
    "x": 270,
    "y": 0
  },
  "1f5dc": {
    "sprite": "objetos",
    "x": 300,
    "y": 0
  },
  "1f4bd": {
    "sprite": "objetos",
    "x": 330,
    "y": 0
  },
  "1f4be": {
    "sprite": "objetos",
    "x": 360,
    "y": 0
  },
  "1f4bf": {
    "sprite": "objetos",
    "x": 390,
    "y": 0
  },
  "1f4c0": {
    "sprite": "objetos",
    "x": 420,
    "y": 0
  },
  "1f4fc": {
    "sprite": "objetos",
    "x": 450,
    "y": 0
  },
  "1f4f7": {
    "sprite": "objetos",
    "x": 0,
    "y": 30
  },
  "1f4f8": {
    "sprite": "objetos",
    "x": 30,
    "y": 30
  },
  "1f4f9": {
    "sprite": "objetos",
    "x": 60,
    "y": 30
  },
  "1f3a5": {
    "sprite": "objetos",
    "x": 90,
    "y": 30
  },
  "1f4fd": {
    "sprite": "objetos",
    "x": 120,
    "y": 30
  },
  "1f39e": {
    "sprite": "objetos",
    "x": 150,
    "y": 30
  },
  "1f4de": {
    "sprite": "objetos",
    "x": 180,
    "y": 30
  },
  "260e": {
    "sprite": "objetos",
    "x": 210,
    "y": 30
  },
  "1f4df": {
    "sprite": "objetos",
    "x": 240,
    "y": 30
  },
  "1f4e0": {
    "sprite": "objetos",
    "x": 270,
    "y": 30
  },
  "1f4fa": {
    "sprite": "objetos",
    "x": 300,
    "y": 30
  },
  "1f4fb": {
    "sprite": "objetos",
    "x": 330,
    "y": 30
  },
  "1f399": {
    "sprite": "objetos",
    "x": 360,
    "y": 30
  },
  "1f39a": {
    "sprite": "objetos",
    "x": 390,
    "y": 30
  },
  "1f39b": {
    "sprite": "objetos",
    "x": 420,
    "y": 30
  },
  "1f9ed": {
    "sprite": "objetos",
    "x": 450,
    "y": 30
  },
  "23f1": {
    "sprite": "objetos",
    "x": 0,
    "y": 60
  },
  "23f2": {
    "sprite": "objetos",
    "x": 30,
    "y": 60
  },
  "23f0": {
    "sprite": "objetos",
    "x": 60,
    "y": 60
  },
  "1f570": {
    "sprite": "objetos",
    "x": 90,
    "y": 60
  },
  "231b": {
    "sprite": "objetos",
    "x": 120,
    "y": 60
  },
  "23f3": {
    "sprite": "objetos",
    "x": 150,
    "y": 60
  },
  "1f4e1": {
    "sprite": "objetos",
    "x": 180,
    "y": 60
  },
  "1f50b": {
    "sprite": "objetos",
    "x": 210,
    "y": 60
  },
  "1faab": {
    "sprite": "objetos",
    "x": 240,
    "y": 60
  },
  "1f50c": {
    "sprite": "objetos",
    "x": 270,
    "y": 60
  },
  "1f4a1": {
    "sprite": "objetos",
    "x": 300,
    "y": 60
  },
  "1f526": {
    "sprite": "objetos",
    "x": 330,
    "y": 60
  },
  "1f56f": {
    "sprite": "objetos",
    "x": 360,
    "y": 60
  },
  "1fa94": {
    "sprite": "objetos",
    "x": 390,
    "y": 60
  },
  "1f9ef": {
    "sprite": "objetos",
    "x": 420,
    "y": 60
  },
  "1f6e2": {
    "sprite": "objetos",
    "x": 450,
    "y": 60
  },
  "1f4b8": {
    "sprite": "objetos",
    "x": 0,
    "y": 90
  },
  "1f4b5": {
    "sprite": "objetos",
    "x": 30,
    "y": 90
  },
  "1f4b4": {
    "sprite": "objetos",
    "x": 60,
    "y": 90
  },
  "1f4b6": {
    "sprite": "objetos",
    "x": 90,
    "y": 90
  },
  "1f4b7": {
    "sprite": "objetos",
    "x": 120,
    "y": 90
  },
  "1fa99": {
    "sprite": "objetos",
    "x": 150,
    "y": 90
  },
  "1f4b0": {
    "sprite": "objetos",
    "x": 180,
    "y": 90
  },
  "1f4b3": {
    "sprite": "objetos",
    "x": 210,
    "y": 90
  },
  "1faaa": {
    "sprite": "objetos",
    "x": 240,
    "y": 90
  },
  "1f48e": {
    "sprite": "objetos",
    "x": 270,
    "y": 90
  },
  "1fa9c": {
    "sprite": "objetos",
    "x": 330,
    "y": 90
  },
  "1f9f0": {
    "sprite": "objetos",
    "x": 360,
    "y": 90
  },
  "1fa9b": {
    "sprite": "objetos",
    "x": 390,
    "y": 90
  },
  "1f527": {
    "sprite": "objetos",
    "x": 420,
    "y": 90
  },
  "1f528": {
    "sprite": "objetos",
    "x": 450,
    "y": 90
  },
  "1f6e0": {
    "sprite": "objetos",
    "x": 30,
    "y": 120
  },
  "26cf": {
    "sprite": "objetos",
    "x": 60,
    "y": 120
  },
  "1fa8f": {
    "sprite": "objetos",
    "x": 90,
    "y": 120
  },
  "1fa9a": {
    "sprite": "objetos",
    "x": 120,
    "y": 120
  },
  "1f529": {
    "sprite": "objetos",
    "x": 150,
    "y": 120
  },
  "1faa4": {
    "sprite": "objetos",
    "x": 210,
    "y": 120
  },
  "1f9f1": {
    "sprite": "objetos",
    "x": 240,
    "y": 120
  },
  "26d3": {
    "sprite": "objetos",
    "x": 270,
    "y": 120
  },
  "26d3-200d-1f4a5": {
    "sprite": "objetos",
    "x": 300,
    "y": 120
  },
  "1f9f2": {
    "sprite": "objetos",
    "x": 330,
    "y": 120
  },
  "1f52b": {
    "sprite": "objetos",
    "x": 360,
    "y": 120
  },
  "1f4a3": {
    "sprite": "objetos",
    "x": 390,
    "y": 120
  },
  "1f9e8": {
    "sprite": "objetos",
    "x": 420,
    "y": 120
  },
  "1fa93": {
    "sprite": "objetos",
    "x": 450,
    "y": 120
  },
  "1f52a": {
    "sprite": "objetos",
    "x": 0,
    "y": 150
  },
  "1f5e1": {
    "sprite": "objetos",
    "x": 30,
    "y": 150
  },
  "1f6e1": {
    "sprite": "objetos",
    "x": 90,
    "y": 150
  },
  "1f6ac": {
    "sprite": "objetos",
    "x": 120,
    "y": 150
  },
  "26b0": {
    "sprite": "objetos",
    "x": 150,
    "y": 150
  },
  "1faa6": {
    "sprite": "objetos",
    "x": 180,
    "y": 150
  },
  "26b1": {
    "sprite": "objetos",
    "x": 210,
    "y": 150
  },
  "1f3fa": {
    "sprite": "objetos",
    "x": 240,
    "y": 150
  },
  "1f52e": {
    "sprite": "objetos",
    "x": 270,
    "y": 150
  },
  "1f4ff": {
    "sprite": "objetos",
    "x": 300,
    "y": 150
  },
  "1f9ff": {
    "sprite": "objetos",
    "x": 330,
    "y": 150
  },
  "1faac": {
    "sprite": "objetos",
    "x": 360,
    "y": 150
  },
  "1f488": {
    "sprite": "objetos",
    "x": 390,
    "y": 150
  },
  "1f52d": {
    "sprite": "objetos",
    "x": 450,
    "y": 150
  },
  "1f52c": {
    "sprite": "objetos",
    "x": 0,
    "y": 180
  },
  "1f573": {
    "sprite": "objetos",
    "x": 30,
    "y": 180
  },
  "1fa7b": {
    "sprite": "objetos",
    "x": 60,
    "y": 180
  },
  "1fa79": {
    "sprite": "objetos",
    "x": 90,
    "y": 180
  },
  "1fa7a": {
    "sprite": "objetos",
    "x": 120,
    "y": 180
  },
  "1f48a": {
    "sprite": "objetos",
    "x": 150,
    "y": 180
  },
  "1f489": {
    "sprite": "objetos",
    "x": 180,
    "y": 180
  },
  "1fa78": {
    "sprite": "objetos",
    "x": 210,
    "y": 180
  },
  "1f9ec": {
    "sprite": "objetos",
    "x": 240,
    "y": 180
  },
  "1f9a0": {
    "sprite": "objetos",
    "x": 270,
    "y": 180
  },
  "1f9eb": {
    "sprite": "objetos",
    "x": 300,
    "y": 180
  },
  "1f9ea": {
    "sprite": "objetos",
    "x": 330,
    "y": 180
  },
  "1f321": {
    "sprite": "objetos",
    "x": 360,
    "y": 180
  },
  "1f9f9": {
    "sprite": "objetos",
    "x": 390,
    "y": 180
  },
  "1faa0": {
    "sprite": "objetos",
    "x": 420,
    "y": 180
  },
  "1f9fa": {
    "sprite": "objetos",
    "x": 450,
    "y": 180
  },
  "1f9fb": {
    "sprite": "objetos",
    "x": 0,
    "y": 210
  },
  "1f6bd": {
    "sprite": "objetos",
    "x": 30,
    "y": 210
  },
  "1f6b0": {
    "sprite": "objetos",
    "x": 60,
    "y": 210
  },
  "1f6bf": {
    "sprite": "objetos",
    "x": 90,
    "y": 210
  },
  "1f6c1": {
    "sprite": "objetos",
    "x": 120,
    "y": 210
  },
  "1f6c0": {
    "sprite": "objetos",
    "x": 150,
    "y": 210
  },
  "1f9fc": {
    "sprite": "objetos",
    "x": 180,
    "y": 210
  },
  "1faa5": {
    "sprite": "objetos",
    "x": 210,
    "y": 210
  },
  "1fa92": {
    "sprite": "objetos",
    "x": 240,
    "y": 210
  },
  "1faae": {
    "sprite": "objetos",
    "x": 270,
    "y": 210
  },
  "1f9fd": {
    "sprite": "objetos",
    "x": 300,
    "y": 210
  },
  "1faa3": {
    "sprite": "objetos",
    "x": 330,
    "y": 210
  },
  "1f9f4": {
    "sprite": "objetos",
    "x": 360,
    "y": 210
  },
  "1f6ce": {
    "sprite": "objetos",
    "x": 390,
    "y": 210
  },
  "1f511": {
    "sprite": "objetos",
    "x": 420,
    "y": 210
  },
  "1f5dd": {
    "sprite": "objetos",
    "x": 450,
    "y": 210
  },
  "1f6aa": {
    "sprite": "objetos",
    "x": 0,
    "y": 240
  },
  "1fa91": {
    "sprite": "objetos",
    "x": 30,
    "y": 240
  },
  "1f6cb": {
    "sprite": "objetos",
    "x": 60,
    "y": 240
  },
  "1f6cf": {
    "sprite": "objetos",
    "x": 90,
    "y": 240
  },
  "1f6cc": {
    "sprite": "objetos",
    "x": 120,
    "y": 240
  },
  "1f9f8": {
    "sprite": "objetos",
    "x": 150,
    "y": 240
  },
  "1fa86": {
    "sprite": "objetos",
    "x": 180,
    "y": 240
  },
  "1f5bc": {
    "sprite": "objetos",
    "x": 210,
    "y": 240
  },
  "1fa9e": {
    "sprite": "objetos",
    "x": 240,
    "y": 240
  },
  "1fa9f": {
    "sprite": "objetos",
    "x": 270,
    "y": 240
  },
  "1f6cd": {
    "sprite": "objetos",
    "x": 300,
    "y": 240
  },
  "1f6d2": {
    "sprite": "objetos",
    "x": 330,
    "y": 240
  },
  "1f381": {
    "sprite": "objetos",
    "x": 360,
    "y": 240
  },
  "1f388": {
    "sprite": "objetos",
    "x": 390,
    "y": 240
  },
  "1f38f": {
    "sprite": "objetos",
    "x": 420,
    "y": 240
  },
  "1f380": {
    "sprite": "objetos",
    "x": 450,
    "y": 240
  },
  "1fa84": {
    "sprite": "objetos",
    "x": 0,
    "y": 270
  },
  "1fa85": {
    "sprite": "objetos",
    "x": 30,
    "y": 270
  },
  "1f38a": {
    "sprite": "objetos",
    "x": 60,
    "y": 270
  },
  "1f389": {
    "sprite": "objetos",
    "x": 90,
    "y": 270
  },
  "1f38e": {
    "sprite": "objetos",
    "x": 120,
    "y": 270
  },
  "1faad": {
    "sprite": "objetos",
    "x": 150,
    "y": 270
  },
  "1f3ee": {
    "sprite": "objetos",
    "x": 180,
    "y": 270
  },
  "1f390": {
    "sprite": "objetos",
    "x": 210,
    "y": 270
  },
  "1faa9": {
    "sprite": "objetos",
    "x": 240,
    "y": 270
  },
  "1f9e7": {
    "sprite": "objetos",
    "x": 270,
    "y": 270
  },
  "1f4e9": {
    "sprite": "objetos",
    "x": 330,
    "y": 270
  },
  "1f4e8": {
    "sprite": "objetos",
    "x": 360,
    "y": 270
  },
  "1f4e7": {
    "sprite": "objetos",
    "x": 390,
    "y": 270
  },
  "1f48c": {
    "sprite": "objetos",
    "x": 420,
    "y": 270
  },
  "1f4e5": {
    "sprite": "objetos",
    "x": 450,
    "y": 270
  },
  "1f4e4": {
    "sprite": "objetos",
    "x": 0,
    "y": 300
  },
  "1f4e6": {
    "sprite": "objetos",
    "x": 30,
    "y": 300
  },
  "1f3f7": {
    "sprite": "objetos",
    "x": 60,
    "y": 300
  },
  "1faa7": {
    "sprite": "objetos",
    "x": 90,
    "y": 300
  },
  "1f4ea": {
    "sprite": "objetos",
    "x": 120,
    "y": 300
  },
  "1f4eb": {
    "sprite": "objetos",
    "x": 150,
    "y": 300
  },
  "1f4ec": {
    "sprite": "objetos",
    "x": 180,
    "y": 300
  },
  "1f4ed": {
    "sprite": "objetos",
    "x": 210,
    "y": 300
  },
  "1f4ee": {
    "sprite": "objetos",
    "x": 240,
    "y": 300
  },
  "1f4ef": {
    "sprite": "objetos",
    "x": 270,
    "y": 300
  },
  "1f4dc": {
    "sprite": "objetos",
    "x": 300,
    "y": 300
  },
  "1f4c3": {
    "sprite": "objetos",
    "x": 330,
    "y": 300
  },
  "1f4c4": {
    "sprite": "objetos",
    "x": 360,
    "y": 300
  },
  "1f4d1": {
    "sprite": "objetos",
    "x": 390,
    "y": 300
  },
  "1f9fe": {
    "sprite": "objetos",
    "x": 420,
    "y": 300
  },
  "1f4ca": {
    "sprite": "objetos",
    "x": 450,
    "y": 300
  },
  "1f4c8": {
    "sprite": "objetos",
    "x": 0,
    "y": 330
  },
  "1f4c9": {
    "sprite": "objetos",
    "x": 30,
    "y": 330
  },
  "1f5d2": {
    "sprite": "objetos",
    "x": 60,
    "y": 330
  },
  "1f5d3": {
    "sprite": "objetos",
    "x": 90,
    "y": 330
  },
  "1f4c6": {
    "sprite": "objetos",
    "x": 120,
    "y": 330
  },
  "1f4c5": {
    "sprite": "objetos",
    "x": 150,
    "y": 330
  },
  "1f5d1": {
    "sprite": "objetos",
    "x": 180,
    "y": 330
  },
  "1f4c7": {
    "sprite": "objetos",
    "x": 210,
    "y": 330
  },
  "1f5c3": {
    "sprite": "objetos",
    "x": 240,
    "y": 330
  },
  "1f5f3": {
    "sprite": "objetos",
    "x": 270,
    "y": 330
  },
  "1f5c4": {
    "sprite": "objetos",
    "x": 300,
    "y": 330
  },
  "1f4cb": {
    "sprite": "objetos",
    "x": 330,
    "y": 330
  },
  "1f4c1": {
    "sprite": "objetos",
    "x": 360,
    "y": 330
  },
  "1f4c2": {
    "sprite": "objetos",
    "x": 390,
    "y": 330
  },
  "1f5c2": {
    "sprite": "objetos",
    "x": 420,
    "y": 330
  },
  "1f5de": {
    "sprite": "objetos",
    "x": 450,
    "y": 330
  },
  "1f4f0": {
    "sprite": "objetos",
    "x": 0,
    "y": 360
  },
  "1f4d3": {
    "sprite": "objetos",
    "x": 30,
    "y": 360
  },
  "1f4d4": {
    "sprite": "objetos",
    "x": 60,
    "y": 360
  },
  "1f4d2": {
    "sprite": "objetos",
    "x": 90,
    "y": 360
  },
  "1f4d5": {
    "sprite": "objetos",
    "x": 120,
    "y": 360
  },
  "1f4d7": {
    "sprite": "objetos",
    "x": 150,
    "y": 360
  },
  "1f4d8": {
    "sprite": "objetos",
    "x": 180,
    "y": 360
  },
  "1f4d9": {
    "sprite": "objetos",
    "x": 210,
    "y": 360
  },
  "1f4da": {
    "sprite": "objetos",
    "x": 240,
    "y": 360
  },
  "1f4d6": {
    "sprite": "objetos",
    "x": 270,
    "y": 360
  },
  "1f516": {
    "sprite": "objetos",
    "x": 300,
    "y": 360
  },
  "1f9f7": {
    "sprite": "objetos",
    "x": 330,
    "y": 360
  },
  "1f517": {
    "sprite": "objetos",
    "x": 360,
    "y": 360
  },
  "1f4ce": {
    "sprite": "objetos",
    "x": 390,
    "y": 360
  },
  "1f587": {
    "sprite": "objetos",
    "x": 420,
    "y": 360
  },
  "1f4d0": {
    "sprite": "objetos",
    "x": 450,
    "y": 360
  },
  "1f4cf": {
    "sprite": "objetos",
    "x": 0,
    "y": 390
  },
  "1f9ee": {
    "sprite": "objetos",
    "x": 30,
    "y": 390
  },
  "1f4cc": {
    "sprite": "objetos",
    "x": 60,
    "y": 390
  },
  "1f4cd": {
    "sprite": "objetos",
    "x": 90,
    "y": 390
  },
  "1f58a": {
    "sprite": "objetos",
    "x": 150,
    "y": 390
  },
  "1f58b": {
    "sprite": "objetos",
    "x": 180,
    "y": 390
  },
  "1f58c": {
    "sprite": "objetos",
    "x": 240,
    "y": 390
  },
  "1f58d": {
    "sprite": "objetos",
    "x": 270,
    "y": 390
  },
  "1f4dd": {
    "sprite": "objetos",
    "x": 300,
    "y": 390
  },
  "270f": {
    "sprite": "objetos",
    "x": 330,
    "y": 390
  },
  "1f50d": {
    "sprite": "objetos",
    "x": 360,
    "y": 390
  },
  "1f50e": {
    "sprite": "objetos",
    "x": 390,
    "y": 390
  },
  "1f50f": {
    "sprite": "objetos",
    "x": 420,
    "y": 390
  },
  "1f510": {
    "sprite": "objetos",
    "x": 450,
    "y": 390
  },
  "1f512": {
    "sprite": "objetos",
    "x": 0,
    "y": 420
  },
  "1f513": {
    "sprite": "objetos",
    "x": 30,
    "y": 420
  },
  "1fa77": {
    "sprite": "simbolos",
    "x": 0,
    "y": 0
  },
  "1f9e1": {
    "sprite": "simbolos",
    "x": 60,
    "y": 0
  },
  "1f49b": {
    "sprite": "simbolos",
    "x": 90,
    "y": 0
  },
  "1f49a": {
    "sprite": "simbolos",
    "x": 120,
    "y": 0
  },
  "1fa75": {
    "sprite": "simbolos",
    "x": 150,
    "y": 0
  },
  "1f499": {
    "sprite": "simbolos",
    "x": 180,
    "y": 0
  },
  "1f49c": {
    "sprite": "simbolos",
    "x": 210,
    "y": 0
  },
  "1f5a4": {
    "sprite": "simbolos",
    "x": 240,
    "y": 0
  },
  "1fa76": {
    "sprite": "simbolos",
    "x": 270,
    "y": 0
  },
  "1f90d": {
    "sprite": "simbolos",
    "x": 300,
    "y": 0
  },
  "1f90e": {
    "sprite": "simbolos",
    "x": 330,
    "y": 0
  },
  "1f494": {
    "sprite": "simbolos",
    "x": 360,
    "y": 0
  },
  "2764-200d-1f525": {
    "sprite": "simbolos",
    "x": 390,
    "y": 0
  },
  "2764-200d-1fa79": {
    "sprite": "simbolos",
    "x": 420,
    "y": 0
  },
  "1f495": {
    "sprite": "simbolos",
    "x": 0,
    "y": 30
  },
  "1f49e": {
    "sprite": "simbolos",
    "x": 30,
    "y": 30
  },
  "1f493": {
    "sprite": "simbolos",
    "x": 60,
    "y": 30
  },
  "1f497": {
    "sprite": "simbolos",
    "x": 90,
    "y": 30
  },
  "1f496": {
    "sprite": "simbolos",
    "x": 120,
    "y": 30
  },
  "1f498": {
    "sprite": "simbolos",
    "x": 150,
    "y": 30
  },
  "1f49d": {
    "sprite": "simbolos",
    "x": 180,
    "y": 30
  },
  "1f49f": {
    "sprite": "simbolos",
    "x": 210,
    "y": 30
  },
  "262e": {
    "sprite": "simbolos",
    "x": 240,
    "y": 30
  },
  "271d": {
    "sprite": "simbolos",
    "x": 270,
    "y": 30
  },
  "262a": {
    "sprite": "simbolos",
    "x": 300,
    "y": 30
  },
  "1f549": {
    "sprite": "simbolos",
    "x": 330,
    "y": 30
  },
  "1faaf": {
    "sprite": "simbolos",
    "x": 390,
    "y": 30
  },
  "1f52f": {
    "sprite": "simbolos",
    "x": 450,
    "y": 30
  },
  "1f54e": {
    "sprite": "simbolos",
    "x": 0,
    "y": 60
  },
  "262f": {
    "sprite": "simbolos",
    "x": 30,
    "y": 60
  },
  "1f6d0": {
    "sprite": "simbolos",
    "x": 90,
    "y": 60
  },
  "26ce": {
    "sprite": "simbolos",
    "x": 120,
    "y": 60
  },
  "264a": {
    "sprite": "simbolos",
    "x": 210,
    "y": 60
  },
  "264b": {
    "sprite": "simbolos",
    "x": 240,
    "y": 60
  },
  "264c": {
    "sprite": "simbolos",
    "x": 270,
    "y": 60
  },
  "264d": {
    "sprite": "simbolos",
    "x": 300,
    "y": 60
  },
  "264e": {
    "sprite": "simbolos",
    "x": 330,
    "y": 60
  },
  "264f": {
    "sprite": "simbolos",
    "x": 360,
    "y": 60
  },
  "1f194": {
    "sprite": "simbolos",
    "x": 30,
    "y": 90
  },
  "269b": {
    "sprite": "simbolos",
    "x": 60,
    "y": 90
  },
  "1f251": {
    "sprite": "simbolos",
    "x": 90,
    "y": 90
  },
  "1f4f4": {
    "sprite": "simbolos",
    "x": 180,
    "y": 90
  },
  "1f4f3": {
    "sprite": "simbolos",
    "x": 210,
    "y": 90
  },
  "1f236": {
    "sprite": "simbolos",
    "x": 240,
    "y": 90
  },
  "1f21a": {
    "sprite": "simbolos",
    "x": 270,
    "y": 90
  },
  "1f238": {
    "sprite": "simbolos",
    "x": 300,
    "y": 90
  },
  "1f23a": {
    "sprite": "simbolos",
    "x": 330,
    "y": 90
  },
  "1f237": {
    "sprite": "simbolos",
    "x": 360,
    "y": 90
  },
  "1f19a": {
    "sprite": "simbolos",
    "x": 420,
    "y": 90
  },
  "1f4ae": {
    "sprite": "simbolos",
    "x": 450,
    "y": 90
  },
  "1f250": {
    "sprite": "simbolos",
    "x": 0,
    "y": 120
  },
  "1f234": {
    "sprite": "simbolos",
    "x": 90,
    "y": 120
  },
  "1f235": {
    "sprite": "simbolos",
    "x": 120,
    "y": 120
  },
  "1f239": {
    "sprite": "simbolos",
    "x": 150,
    "y": 120
  },
  "1f232": {
    "sprite": "simbolos",
    "x": 180,
    "y": 120
  },
  "1f170": {
    "sprite": "simbolos",
    "x": 210,
    "y": 120
  },
  "1f171": {
    "sprite": "simbolos",
    "x": 240,
    "y": 120
  },
  "1f18e": {
    "sprite": "simbolos",
    "x": 270,
    "y": 120
  },
  "1f191": {
    "sprite": "simbolos",
    "x": 300,
    "y": 120
  },
  "1f17e": {
    "sprite": "simbolos",
    "x": 330,
    "y": 120
  },
  "1f198": {
    "sprite": "simbolos",
    "x": 360,
    "y": 120
  },
  "274c": {
    "sprite": "simbolos",
    "x": 390,
    "y": 120
  },
  "2b55": {
    "sprite": "simbolos",
    "x": 420,
    "y": 120
  },
  "1f6d1": {
    "sprite": "simbolos",
    "x": 450,
    "y": 120
  },
  "26d4": {
    "sprite": "simbolos",
    "x": 0,
    "y": 150
  },
  "1f4db": {
    "sprite": "simbolos",
    "x": 30,
    "y": 150
  },
  "1f6ab": {
    "sprite": "simbolos",
    "x": 60,
    "y": 150
  },
  "1f4af": {
    "sprite": "simbolos",
    "x": 90,
    "y": 150
  },
  "1f4a2": {
    "sprite": "simbolos",
    "x": 120,
    "y": 150
  },
  "1f6b7": {
    "sprite": "simbolos",
    "x": 180,
    "y": 150
  },
  "1f6af": {
    "sprite": "simbolos",
    "x": 210,
    "y": 150
  },
  "1f6b3": {
    "sprite": "simbolos",
    "x": 240,
    "y": 150
  },
  "1f6b1": {
    "sprite": "simbolos",
    "x": 270,
    "y": 150
  },
  "1f51e": {
    "sprite": "simbolos",
    "x": 300,
    "y": 150
  },
  "1f4f5": {
    "sprite": "simbolos",
    "x": 330,
    "y": 150
  },
  "1f6ad": {
    "sprite": "simbolos",
    "x": 360,
    "y": 150
  },
  "203c": {
    "sprite": "simbolos",
    "x": 30,
    "y": 180
  },
  "1f505": {
    "sprite": "simbolos",
    "x": 90,
    "y": 180
  },
  "1f506": {
    "sprite": "simbolos",
    "x": 120,
    "y": 180
  },
  "303d": {
    "sprite": "simbolos",
    "x": 150,
    "y": 180
  },
  "26a0": {
    "sprite": "simbolos",
    "x": 180,
    "y": 180
  },
  "1f6b8": {
    "sprite": "simbolos",
    "x": 210,
    "y": 180
  },
  "1f531": {
    "sprite": "simbolos",
    "x": 240,
    "y": 180
  },
  "269c": {
    "sprite": "simbolos",
    "x": 270,
    "y": 180
  },
  "1f530": {
    "sprite": "simbolos",
    "x": 300,
    "y": 180
  },
  "267b": {
    "sprite": "simbolos",
    "x": 330,
    "y": 180
  },
  "1f22f": {
    "sprite": "simbolos",
    "x": 390,
    "y": 180
  },
  "1f4b9": {
    "sprite": "simbolos",
    "x": 420,
    "y": 180
  },
  "274e": {
    "sprite": "simbolos",
    "x": 30,
    "y": 210
  },
  "1f310": {
    "sprite": "simbolos",
    "x": 60,
    "y": 210
  },
  "1f4a0": {
    "sprite": "simbolos",
    "x": 90,
    "y": 210
  },
  "24c2": {
    "sprite": "simbolos",
    "x": 120,
    "y": 210
  },
  "1f300": {
    "sprite": "simbolos",
    "x": 150,
    "y": 210
  },
  "1f4a4": {
    "sprite": "simbolos",
    "x": 180,
    "y": 210
  },
  "1f3e7": {
    "sprite": "simbolos",
    "x": 210,
    "y": 210
  },
  "1f6be": {
    "sprite": "simbolos",
    "x": 240,
    "y": 210
  },
  "267f": {
    "sprite": "simbolos",
    "x": 270,
    "y": 210
  },
  "1f17f": {
    "sprite": "simbolos",
    "x": 300,
    "y": 210
  },
  "1f6d7": {
    "sprite": "simbolos",
    "x": 330,
    "y": 210
  },
  "1f233": {
    "sprite": "simbolos",
    "x": 360,
    "y": 210
  },
  "1f202": {
    "sprite": "simbolos",
    "x": 390,
    "y": 210
  },
  "1f6c2": {
    "sprite": "simbolos",
    "x": 420,
    "y": 210
  },
  "1f6c3": {
    "sprite": "simbolos",
    "x": 450,
    "y": 210
  },
  "1f6c4": {
    "sprite": "simbolos",
    "x": 0,
    "y": 240
  },
  "1f6c5": {
    "sprite": "simbolos",
    "x": 30,
    "y": 240
  },
  "1f6dc": {
    "sprite": "simbolos",
    "x": 60,
    "y": 240
  },
  "1f6b9": {
    "sprite": "simbolos",
    "x": 90,
    "y": 240
  },
  "1f6ba": {
    "sprite": "simbolos",
    "x": 120,
    "y": 240
  },
  "1f6bc": {
    "sprite": "simbolos",
    "x": 150,
    "y": 240
  },
  "1f9d1-200d-1f9d1-200d-1f9d2": {
    "sprite": "simbolos",
    "x": 180,
    "y": 240
  },
  "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2": {
    "sprite": "simbolos",
    "x": 210,
    "y": 240
  },
  "1f9d1-200d-1f9d2": {
    "sprite": "simbolos",
    "x": 240,
    "y": 240
  },
  "1f9d1-200d-1f9d2-200d-1f9d2": {
    "sprite": "simbolos",
    "x": 270,
    "y": 240
  },
  "26a7": {
    "sprite": "simbolos",
    "x": 300,
    "y": 240
  },
  "1f6bb": {
    "sprite": "simbolos",
    "x": 330,
    "y": 240
  },
  "1f6ae": {
    "sprite": "simbolos",
    "x": 360,
    "y": 240
  },
  "1f3a6": {
    "sprite": "simbolos",
    "x": 390,
    "y": 240
  },
  "1f4f6": {
    "sprite": "simbolos",
    "x": 420,
    "y": 240
  },
  "1f201": {
    "sprite": "simbolos",
    "x": 450,
    "y": 240
  },
  "1f523": {
    "sprite": "simbolos",
    "x": 0,
    "y": 270
  },
  "1f524": {
    "sprite": "simbolos",
    "x": 60,
    "y": 270
  },
  "1f521": {
    "sprite": "simbolos",
    "x": 90,
    "y": 270
  },
  "1f520": {
    "sprite": "simbolos",
    "x": 120,
    "y": 270
  },
  "1f196": {
    "sprite": "simbolos",
    "x": 150,
    "y": 270
  },
  "1f197": {
    "sprite": "simbolos",
    "x": 180,
    "y": 270
  },
  "1f199": {
    "sprite": "simbolos",
    "x": 210,
    "y": 270
  },
  "1f192": {
    "sprite": "simbolos",
    "x": 240,
    "y": 270
  },
  "1f195": {
    "sprite": "simbolos",
    "x": 270,
    "y": 270
  },
  "1f193": {
    "sprite": "simbolos",
    "x": 300,
    "y": 270
  },
  "30-20e3": {
    "sprite": "simbolos",
    "x": 330,
    "y": 270
  },
  "31-20e3": {
    "sprite": "simbolos",
    "x": 360,
    "y": 270
  },
  "32-20e3": {
    "sprite": "simbolos",
    "x": 390,
    "y": 270
  },
  "33-20e3": {
    "sprite": "simbolos",
    "x": 420,
    "y": 270
  },
  "34-20e3": {
    "sprite": "simbolos",
    "x": 450,
    "y": 270
  },
  "35-20e3": {
    "sprite": "simbolos",
    "x": 0,
    "y": 300
  },
  "36-20e3": {
    "sprite": "simbolos",
    "x": 30,
    "y": 300
  },
  "37-20e3": {
    "sprite": "simbolos",
    "x": 60,
    "y": 300
  },
  "38-20e3": {
    "sprite": "simbolos",
    "x": 90,
    "y": 300
  },
  "39-20e3": {
    "sprite": "simbolos",
    "x": 120,
    "y": 300
  },
  "1f51f": {
    "sprite": "simbolos",
    "x": 150,
    "y": 300
  },
  "1f522": {
    "sprite": "simbolos",
    "x": 180,
    "y": 300
  },
  "23-20e3": {
    "sprite": "simbolos",
    "x": 210,
    "y": 300
  },
  "2a-20e3": {
    "sprite": "simbolos",
    "x": 240,
    "y": 300
  },
  "23cf": {
    "sprite": "simbolos",
    "x": 270,
    "y": 300
  },
  "25b6": {
    "sprite": "simbolos",
    "x": 300,
    "y": 300
  },
  "23f8": {
    "sprite": "simbolos",
    "x": 330,
    "y": 300
  },
  "23ef": {
    "sprite": "simbolos",
    "x": 360,
    "y": 300
  },
  "23f9": {
    "sprite": "simbolos",
    "x": 390,
    "y": 300
  },
  "23fa": {
    "sprite": "simbolos",
    "x": 420,
    "y": 300
  },
  "23ed": {
    "sprite": "simbolos",
    "x": 450,
    "y": 300
  },
  "23ee": {
    "sprite": "simbolos",
    "x": 0,
    "y": 330
  },
  "23e9": {
    "sprite": "simbolos",
    "x": 30,
    "y": 330
  },
  "23ea": {
    "sprite": "simbolos",
    "x": 60,
    "y": 330
  },
  "23eb": {
    "sprite": "simbolos",
    "x": 90,
    "y": 330
  },
  "23ec": {
    "sprite": "simbolos",
    "x": 120,
    "y": 330
  },
  "25c0": {
    "sprite": "simbolos",
    "x": 150,
    "y": 330
  },
  "1f53c": {
    "sprite": "simbolos",
    "x": 180,
    "y": 330
  },
  "1f53d": {
    "sprite": "simbolos",
    "x": 210,
    "y": 330
  },
  "27a1": {
    "sprite": "simbolos",
    "x": 240,
    "y": 330
  },
  "2b05": {
    "sprite": "simbolos",
    "x": 270,
    "y": 330
  },
  "2b06": {
    "sprite": "simbolos",
    "x": 300,
    "y": 330
  },
  "2b07": {
    "sprite": "simbolos",
    "x": 330,
    "y": 330
  },
  "21aa": {
    "sprite": "simbolos",
    "x": 60,
    "y": 360
  },
  "21a9": {
    "sprite": "simbolos",
    "x": 90,
    "y": 360
  },
  "1f500": {
    "sprite": "simbolos",
    "x": 180,
    "y": 360
  },
  "1f501": {
    "sprite": "simbolos",
    "x": 210,
    "y": 360
  },
  "1f502": {
    "sprite": "simbolos",
    "x": 240,
    "y": 360
  },
  "1f504": {
    "sprite": "simbolos",
    "x": 270,
    "y": 360
  },
  "1f503": {
    "sprite": "simbolos",
    "x": 300,
    "y": 360
  },
  "1f3b5": {
    "sprite": "simbolos",
    "x": 330,
    "y": 360
  },
  "1f3b6": {
    "sprite": "simbolos",
    "x": 360,
    "y": 360
  },
  "1f7f0": {
    "sprite": "simbolos",
    "x": 30,
    "y": 390
  },
  "267e": {
    "sprite": "simbolos",
    "x": 60,
    "y": 390
  },
  "1f4b2": {
    "sprite": "simbolos",
    "x": 90,
    "y": 390
  },
  "1f4b1": {
    "sprite": "simbolos",
    "x": 120,
    "y": 390
  },
  "a9": {
    "sprite": "simbolos",
    "x": 180,
    "y": 390
  },
  "ae": {
    "sprite": "simbolos",
    "x": 210,
    "y": 390
  },
  "1f441-200d-1f5e8": {
    "sprite": "simbolos",
    "x": 240,
    "y": 390
  },
  "1f51a": {
    "sprite": "simbolos",
    "x": 270,
    "y": 390
  },
  "1f519": {
    "sprite": "simbolos",
    "x": 300,
    "y": 390
  },
  "1f51b": {
    "sprite": "simbolos",
    "x": 330,
    "y": 390
  },
  "1f51d": {
    "sprite": "simbolos",
    "x": 360,
    "y": 390
  },
  "1f51c": {
    "sprite": "simbolos",
    "x": 390,
    "y": 390
  },
  "27b0": {
    "sprite": "simbolos",
    "x": 450,
    "y": 390
  },
  "27bf": {
    "sprite": "simbolos",
    "x": 0,
    "y": 420
  },
  "1f518": {
    "sprite": "simbolos",
    "x": 90,
    "y": 420
  },
  "1f534": {
    "sprite": "simbolos",
    "x": 120,
    "y": 420
  },
  "1f7e0": {
    "sprite": "simbolos",
    "x": 150,
    "y": 420
  },
  "1f7e1": {
    "sprite": "simbolos",
    "x": 180,
    "y": 420
  },
  "1f7e2": {
    "sprite": "simbolos",
    "x": 210,
    "y": 420
  },
  "1f535": {
    "sprite": "simbolos",
    "x": 240,
    "y": 420
  },
  "1f7e3": {
    "sprite": "simbolos",
    "x": 270,
    "y": 420
  },
  "26ab": {
    "sprite": "simbolos",
    "x": 300,
    "y": 420
  },
  "26aa": {
    "sprite": "simbolos",
    "x": 330,
    "y": 420
  },
  "1f7e4": {
    "sprite": "simbolos",
    "x": 360,
    "y": 420
  },
  "1f53a": {
    "sprite": "simbolos",
    "x": 390,
    "y": 420
  },
  "1f53b": {
    "sprite": "simbolos",
    "x": 420,
    "y": 420
  },
  "1f538": {
    "sprite": "simbolos",
    "x": 450,
    "y": 420
  },
  "1f539": {
    "sprite": "simbolos",
    "x": 0,
    "y": 450
  },
  "1f536": {
    "sprite": "simbolos",
    "x": 30,
    "y": 450
  },
  "1f537": {
    "sprite": "simbolos",
    "x": 60,
    "y": 450
  },
  "1f533": {
    "sprite": "simbolos",
    "x": 90,
    "y": 450
  },
  "1f532": {
    "sprite": "simbolos",
    "x": 120,
    "y": 450
  },
  "25aa": {
    "sprite": "simbolos",
    "x": 150,
    "y": 450
  },
  "25ab": {
    "sprite": "simbolos",
    "x": 180,
    "y": 450
  },
  "25fe": {
    "sprite": "simbolos",
    "x": 210,
    "y": 450
  },
  "25fd": {
    "sprite": "simbolos",
    "x": 240,
    "y": 450
  },
  "25fc": {
    "sprite": "simbolos",
    "x": 270,
    "y": 450
  },
  "25fb": {
    "sprite": "simbolos",
    "x": 300,
    "y": 450
  },
  "1f7e5": {
    "sprite": "simbolos",
    "x": 330,
    "y": 450
  },
  "1f7e7": {
    "sprite": "simbolos",
    "x": 360,
    "y": 450
  },
  "1f7e8": {
    "sprite": "simbolos",
    "x": 390,
    "y": 450
  },
  "1f7e9": {
    "sprite": "simbolos",
    "x": 420,
    "y": 450
  },
  "1f7e6": {
    "sprite": "simbolos",
    "x": 450,
    "y": 450
  },
  "1f7ea": {
    "sprite": "simbolos",
    "x": 0,
    "y": 480
  },
  "2b1b": {
    "sprite": "simbolos",
    "x": 30,
    "y": 480
  },
  "2b1c": {
    "sprite": "simbolos",
    "x": 60,
    "y": 480
  },
  "1f7eb": {
    "sprite": "simbolos",
    "x": 90,
    "y": 480
  },
  "1f508": {
    "sprite": "simbolos",
    "x": 120,
    "y": 480
  },
  "1f507": {
    "sprite": "simbolos",
    "x": 150,
    "y": 480
  },
  "1f509": {
    "sprite": "simbolos",
    "x": 180,
    "y": 480
  },
  "1f50a": {
    "sprite": "simbolos",
    "x": 210,
    "y": 480
  },
  "1f514": {
    "sprite": "simbolos",
    "x": 240,
    "y": 480
  },
  "1f515": {
    "sprite": "simbolos",
    "x": 270,
    "y": 480
  },
  "1f4e3": {
    "sprite": "simbolos",
    "x": 300,
    "y": 480
  },
  "1f4e2": {
    "sprite": "simbolos",
    "x": 330,
    "y": 480
  },
  "1f4ac": {
    "sprite": "simbolos",
    "x": 360,
    "y": 480
  },
  "1f4ad": {
    "sprite": "simbolos",
    "x": 390,
    "y": 480
  },
  "1f5ef": {
    "sprite": "simbolos",
    "x": 420,
    "y": 480
  },
  "1f0cf": {
    "sprite": "simbolos",
    "x": 90,
    "y": 510
  },
  "1f3b4": {
    "sprite": "simbolos",
    "x": 120,
    "y": 510
  },
  "1f004": {
    "sprite": "simbolos",
    "x": 150,
    "y": 510
  },
  "1f550": {
    "sprite": "simbolos",
    "x": 180,
    "y": 510
  },
  "1f551": {
    "sprite": "simbolos",
    "x": 210,
    "y": 510
  },
  "1f552": {
    "sprite": "simbolos",
    "x": 240,
    "y": 510
  },
  "1f553": {
    "sprite": "simbolos",
    "x": 270,
    "y": 510
  },
  "1f554": {
    "sprite": "simbolos",
    "x": 300,
    "y": 510
  },
  "1f555": {
    "sprite": "simbolos",
    "x": 330,
    "y": 510
  },
  "1f556": {
    "sprite": "simbolos",
    "x": 360,
    "y": 510
  },
  "1f557": {
    "sprite": "simbolos",
    "x": 390,
    "y": 510
  },
  "1f558": {
    "sprite": "simbolos",
    "x": 420,
    "y": 510
  },
  "1f559": {
    "sprite": "simbolos",
    "x": 450,
    "y": 510
  },
  "1f55a": {
    "sprite": "simbolos",
    "x": 0,
    "y": 540
  },
  "1f55b": {
    "sprite": "simbolos",
    "x": 30,
    "y": 540
  },
  "1f55c": {
    "sprite": "simbolos",
    "x": 60,
    "y": 540
  },
  "1f55d": {
    "sprite": "simbolos",
    "x": 90,
    "y": 540
  },
  "1f55e": {
    "sprite": "simbolos",
    "x": 120,
    "y": 540
  },
  "1f55f": {
    "sprite": "simbolos",
    "x": 150,
    "y": 540
  },
  "1f560": {
    "sprite": "simbolos",
    "x": 180,
    "y": 540
  },
  "1f561": {
    "sprite": "simbolos",
    "x": 210,
    "y": 540
  },
  "1f562": {
    "sprite": "simbolos",
    "x": 240,
    "y": 540
  },
  "1f563": {
    "sprite": "simbolos",
    "x": 270,
    "y": 540
  },
  "1f564": {
    "sprite": "simbolos",
    "x": 300,
    "y": 540
  },
  "1f565": {
    "sprite": "simbolos",
    "x": 330,
    "y": 540
  },
  "1f566": {
    "sprite": "simbolos",
    "x": 360,
    "y": 540
  },
  "1f567": {
    "sprite": "simbolos",
    "x": 390,
    "y": 540
  },
  "1f3f3": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 0
  },
  "1f3f4": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 0
  },
  "1f3f4-200d-2620": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 0
  },
  "1f3c1": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 0
  },
  "1f6a9": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 0
  },
  "1f3f3-200d-1f308": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 0
  },
  "1f3f3-200d-26a7": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 0
  },
  "1f1fa-1f1f3": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 0
  },
  "1f1e6-1f1eb": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 0
  },
  "1f1e6-1f1fd": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 0
  },
  "1f1e6-1f1f1": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 0
  },
  "1f1e9-1f1ff": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 0
  },
  "1f1e6-1f1f8": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 0
  },
  "1f1e6-1f1e9": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 0
  },
  "1f1e6-1f1f4": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 0
  },
  "1f1e6-1f1ee": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 0
  },
  "1f1e6-1f1f6": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 30
  },
  "1f1e6-1f1ec": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 30
  },
  "1f1e6-1f1f7": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 30
  },
  "1f1e6-1f1f2": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 30
  },
  "1f1e6-1f1fc": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 30
  },
  "1f1e6-1f1fa": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 30
  },
  "1f1e6-1f1f9": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 30
  },
  "1f1e6-1f1ff": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 30
  },
  "1f1e7-1f1f8": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 30
  },
  "1f1e7-1f1ed": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 30
  },
  "1f1e7-1f1e9": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 30
  },
  "1f1e7-1f1e7": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 30
  },
  "1f1e7-1f1fe": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 30
  },
  "1f1e7-1f1ea": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 30
  },
  "1f1e7-1f1ff": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 30
  },
  "1f1e7-1f1ef": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 30
  },
  "1f1e7-1f1f2": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 60
  },
  "1f1e7-1f1f9": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 60
  },
  "1f1e7-1f1f4": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 60
  },
  "1f1e7-1f1e6": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 60
  },
  "1f1e7-1f1fc": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 60
  },
  "1f1e7-1f1f7": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 60
  },
  "1f1fb-1f1ec": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 60
  },
  "1f1e7-1f1f3": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 60
  },
  "1f1e7-1f1ec": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 60
  },
  "1f1e7-1f1eb": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 60
  },
  "1f1e7-1f1ee": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 60
  },
  "1f1f0-1f1ed": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 60
  },
  "1f1e8-1f1f2": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 60
  },
  "1f1e8-1f1e6": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 60
  },
  "1f1ee-1f1e8": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 60
  },
  "1f1e8-1f1fb": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 60
  },
  "1f1e7-1f1f6": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 90
  },
  "1f1f0-1f1fe": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 90
  },
  "1f1e8-1f1eb": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 90
  },
  "1f1f9-1f1e9": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 90
  },
  "1f1ee-1f1f4": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 90
  },
  "1f1e8-1f1f1": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 90
  },
  "1f1e8-1f1f3": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 90
  },
  "1f1e8-1f1fd": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 90
  },
  "1f1e8-1f1e8": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 90
  },
  "1f1e8-1f1f4": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 90
  },
  "1f1f0-1f1f2": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 90
  },
  "1f1e8-1f1ec": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 90
  },
  "1f1e8-1f1e9": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 90
  },
  "1f1e8-1f1f0": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 90
  },
  "1f1e8-1f1f7": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 90
  },
  "1f1e8-1f1ee": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 90
  },
  "1f1ed-1f1f7": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 120
  },
  "1f1e8-1f1fa": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 120
  },
  "1f1e8-1f1fc": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 120
  },
  "1f1e8-1f1fe": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 120
  },
  "1f1e8-1f1ff": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 120
  },
  "1f1e9-1f1f0": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 120
  },
  "1f1e9-1f1ef": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 120
  },
  "1f1e9-1f1f2": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 120
  },
  "1f1e9-1f1f4": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 120
  },
  "1f1ea-1f1e8": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 120
  },
  "1f1ea-1f1ec": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 120
  },
  "1f1f8-1f1fb": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 120
  },
  "1f1ec-1f1f6": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 120
  },
  "1f1ea-1f1f7": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 120
  },
  "1f1ea-1f1ea": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 120
  },
  "1f1f8-1f1ff": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 120
  },
  "1f1ea-1f1f9": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 150
  },
  "1f1ea-1f1fa": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 150
  },
  "1f1eb-1f1f0": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 150
  },
  "1f1eb-1f1f4": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 150
  },
  "1f1eb-1f1ef": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 150
  },
  "1f1eb-1f1ee": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 150
  },
  "1f1eb-1f1f7": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 150
  },
  "1f1ec-1f1eb": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 150
  },
  "1f1f5-1f1eb": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 150
  },
  "1f1f9-1f1eb": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 150
  },
  "1f1ec-1f1e6": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 150
  },
  "1f1ec-1f1f2": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 150
  },
  "1f1ec-1f1ea": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 150
  },
  "1f1e9-1f1ea": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 150
  },
  "1f1ec-1f1ed": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 150
  },
  "1f1ec-1f1ee": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 150
  },
  "1f1ec-1f1f7": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 180
  },
  "1f1ec-1f1f1": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 180
  },
  "1f1ec-1f1e9": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 180
  },
  "1f1ec-1f1f5": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 180
  },
  "1f1ec-1f1fa": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 180
  },
  "1f1ec-1f1f9": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 180
  },
  "1f1ec-1f1ec": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 180
  },
  "1f1ec-1f1f3": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 180
  },
  "1f1ec-1f1fc": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 180
  },
  "1f1ec-1f1fe": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 180
  },
  "1f1ed-1f1f9": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 180
  },
  "1f1ed-1f1f3": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 180
  },
  "1f1ed-1f1f0": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 180
  },
  "1f1ed-1f1fa": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 180
  },
  "1f1ee-1f1f8": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 180
  },
  "1f1ee-1f1f3": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 180
  },
  "1f1ee-1f1e9": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 210
  },
  "1f1ee-1f1f7": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 210
  },
  "1f1ee-1f1f6": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 210
  },
  "1f1ee-1f1ea": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 210
  },
  "1f1ee-1f1f2": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 210
  },
  "1f1ee-1f1f1": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 210
  },
  "1f1ee-1f1f9": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 210
  },
  "1f1ef-1f1f2": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 210
  },
  "1f1ef-1f1f5": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 210
  },
  "1f38c": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 210
  },
  "1f1ef-1f1ea": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 210
  },
  "1f1ef-1f1f4": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 210
  },
  "1f1f0-1f1ff": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 210
  },
  "1f1f0-1f1ea": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 210
  },
  "1f1f0-1f1ee": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 210
  },
  "1f1fd-1f1f0": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 210
  },
  "1f1f0-1f1fc": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 240
  },
  "1f1f0-1f1ec": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 240
  },
  "1f1f1-1f1e6": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 240
  },
  "1f1f1-1f1fb": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 240
  },
  "1f1f1-1f1e7": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 240
  },
  "1f1f1-1f1f8": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 240
  },
  "1f1f1-1f1f7": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 240
  },
  "1f1f1-1f1fe": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 240
  },
  "1f1f1-1f1ee": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 240
  },
  "1f1f1-1f1f9": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 240
  },
  "1f1f1-1f1fa": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 240
  },
  "1f1f2-1f1f4": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 240
  },
  "1f1f2-1f1ec": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 240
  },
  "1f1f2-1f1fc": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 240
  },
  "1f1f2-1f1fe": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 240
  },
  "1f1f2-1f1fb": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 240
  },
  "1f1f2-1f1f1": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 270
  },
  "1f1f2-1f1f9": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 270
  },
  "1f1f2-1f1ed": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 270
  },
  "1f1f2-1f1f6": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 270
  },
  "1f1f2-1f1f7": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 270
  },
  "1f1f2-1f1fa": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 270
  },
  "1f1fe-1f1f9": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 270
  },
  "1f1f2-1f1fd": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 270
  },
  "1f1eb-1f1f2": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 270
  },
  "1f1f2-1f1e9": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 270
  },
  "1f1f2-1f1e8": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 270
  },
  "1f1f2-1f1f3": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 270
  },
  "1f1f2-1f1ea": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 270
  },
  "1f1f2-1f1f8": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 270
  },
  "1f1f2-1f1e6": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 270
  },
  "1f1f2-1f1ff": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 270
  },
  "1f1f2-1f1f2": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 300
  },
  "1f1f3-1f1e6": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 300
  },
  "1f1f3-1f1f7": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 300
  },
  "1f1f3-1f1f5": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 300
  },
  "1f1f3-1f1f1": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 300
  },
  "1f1f3-1f1e8": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 300
  },
  "1f1f3-1f1ff": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 300
  },
  "1f1f3-1f1ee": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 300
  },
  "1f1f3-1f1ea": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 300
  },
  "1f1f3-1f1ec": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 300
  },
  "1f1f3-1f1fa": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 300
  },
  "1f1f3-1f1eb": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 300
  },
  "1f1f0-1f1f5": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 300
  },
  "1f1f2-1f1f0": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 300
  },
  "1f1f2-1f1f5": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 300
  },
  "1f1f3-1f1f4": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 300
  },
  "1f1f4-1f1f2": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 330
  },
  "1f1f5-1f1f0": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 330
  },
  "1f1f5-1f1fc": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 330
  },
  "1f1f5-1f1f8": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 330
  },
  "1f1f5-1f1e6": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 330
  },
  "1f1f5-1f1ec": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 330
  },
  "1f1f5-1f1fe": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 330
  },
  "1f1f5-1f1ea": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 330
  },
  "1f1f5-1f1ed": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 330
  },
  "1f1f5-1f1f3": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 330
  },
  "1f1f5-1f1f1": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 330
  },
  "1f1f5-1f1f9": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 330
  },
  "1f1f5-1f1f7": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 330
  },
  "1f1f6-1f1e6": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 330
  },
  "1f1f7-1f1ea": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 330
  },
  "1f1f7-1f1f4": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 330
  },
  "1f1f7-1f1fa": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 360
  },
  "1f1f7-1f1fc": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 360
  },
  "1f1fc-1f1f8": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 360
  },
  "1f1f8-1f1f2": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 360
  },
  "1f1f8-1f1f9": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 360
  },
  "1f1e8-1f1f6": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 360
  },
  "1f1f8-1f1e6": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 360
  },
  "1f1f8-1f1f3": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 360
  },
  "1f1f7-1f1f8": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 360
  },
  "1f1f8-1f1e8": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 360
  },
  "1f1f8-1f1f1": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 360
  },
  "1f1f8-1f1ec": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 360
  },
  "1f1f8-1f1fd": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 360
  },
  "1f1f8-1f1f0": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 360
  },
  "1f1f8-1f1ee": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 360
  },
  "1f1ec-1f1f8": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 360
  },
  "1f1f8-1f1e7": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 390
  },
  "1f1f8-1f1f4": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 390
  },
  "1f1ff-1f1e6": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 390
  },
  "1f1f0-1f1f7": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 390
  },
  "1f1f8-1f1f8": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 390
  },
  "1f1ea-1f1f8": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 390
  },
  "1f1f1-1f1f0": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 390
  },
  "1f1e7-1f1f1": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 390
  },
  "1f1f8-1f1ed": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 390
  },
  "1f1f0-1f1f3": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 390
  },
  "1f1f1-1f1e8": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 390
  },
  "1f1f5-1f1f2": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 390
  },
  "1f1fb-1f1e8": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 390
  },
  "1f1f8-1f1e9": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 390
  },
  "1f1f8-1f1f7": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 390
  },
  "1f1f8-1f1ea": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 390
  },
  "1f1e8-1f1ed": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 420
  },
  "1f1f8-1f1fe": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 420
  },
  "1f1f9-1f1fc": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 420
  },
  "1f1f9-1f1ef": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 420
  },
  "1f1f9-1f1ff": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 420
  },
  "1f1f9-1f1ed": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 420
  },
  "1f1f9-1f1f1": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 420
  },
  "1f1f9-1f1ec": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 420
  },
  "1f1f9-1f1f0": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 420
  },
  "1f1f9-1f1f4": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 420
  },
  "1f1f9-1f1f9": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 420
  },
  "1f1f9-1f1f3": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 420
  },
  "1f1f9-1f1f7": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 420
  },
  "1f1f9-1f1f2": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 420
  },
  "1f1f9-1f1e8": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 420
  },
  "1f1f9-1f1fb": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 420
  },
  "1f1fb-1f1ee": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 450
  },
  "1f1fa-1f1ec": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 450
  },
  "1f1fa-1f1e6": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 450
  },
  "1f1e6-1f1ea": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 450
  },
  "1f1ec-1f1e7": {
    "sprite": "bandeiras",
    "x": 120,
    "y": 450
  },
  "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f": {
    "sprite": "bandeiras",
    "x": 150,
    "y": 450
  },
  "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f": {
    "sprite": "bandeiras",
    "x": 180,
    "y": 450
  },
  "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f": {
    "sprite": "bandeiras",
    "x": 210,
    "y": 450
  },
  "1f1fa-1f1f8": {
    "sprite": "bandeiras",
    "x": 240,
    "y": 450
  },
  "1f1fa-1f1fe": {
    "sprite": "bandeiras",
    "x": 270,
    "y": 450
  },
  "1f1fa-1f1ff": {
    "sprite": "bandeiras",
    "x": 300,
    "y": 450
  },
  "1f1fb-1f1fa": {
    "sprite": "bandeiras",
    "x": 330,
    "y": 450
  },
  "1f1fb-1f1e6": {
    "sprite": "bandeiras",
    "x": 360,
    "y": 450
  },
  "1f1fb-1f1ea": {
    "sprite": "bandeiras",
    "x": 390,
    "y": 450
  },
  "1f1fb-1f1f3": {
    "sprite": "bandeiras",
    "x": 420,
    "y": 450
  },
  "1f1fc-1f1eb": {
    "sprite": "bandeiras",
    "x": 450,
    "y": 450
  },
  "1f1ea-1f1ed": {
    "sprite": "bandeiras",
    "x": 0,
    "y": 480
  },
  "1f1fe-1f1ea": {
    "sprite": "bandeiras",
    "x": 30,
    "y": 480
  },
  "1f1ff-1f1f2": {
    "sprite": "bandeiras",
    "x": 60,
    "y": 480
  },
  "1f1ff-1f1fc": {
    "sprite": "bandeiras",
    "x": 90,
    "y": 480
  }
}

export { whatsAppEmojiSprites, whatsAppEmojiSpriteMap }
